<template>
    <center>
        <div class="modal fade" id="costumModaldisclaimer" data-easein="flipBounceYIn" tabindex="-1" role="dialog"
            aria-labelledby="costumModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false"
            style="background: rgba(240, 248, 255, 0.1);width: 98vw;height: 98%;">
            <div class="modal-dialog modal-fullscreen">
                <div class="modal-content" style="height: auto;min-width: 90vw; min-height: 98%;">
                    <div class="modal-header" style="background-color: #24649e;">
                        <h4 class="modal-title text-white">Cetak</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body text-center"
                        style="height: auto;min-width: 90vw; min-height: 98%;overflow: auto;">
                        <p>
                        <div class="col-sm-12">
                            <iframe :src="sourcenyacetak" id="iframefile" @load="loadpdf()"
                                style="width: 100%;height: 75vh;"></iframe>
                        </div>
                        </p>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <div class="col-sm-12 text-center">
                            <button class="btn btn-danger2 lebar2 btn-block text-white" placeholder="Tutup"
                                data-toggle="tooltip" data-placement="left" title="Tutup.." style="color: black;"
                                data-dismiss="modal">
                                <b>
                                    <i class="fas fa-window-close"></i> Tutup
                                </b>
                            </button>
                        </div>
                    </div>
                </div>
                <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
        </div>
    </center>
    <div id="mySidenavLegenda" class="sidenav p-0" style="background-color: #ffffff;">
        <div class="card card-warning shadow-none">
            <div class="card-header" style="background-color: #005c95 !important;color: #ffffff;">
                <h3 class="card-title text-white">
                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                        Legenda Peta
                    </span>
                    <span v-else>
                        Map Legend
                    </span>
                </h3>
                <!-- /.card-tools -->
                <div class="card-toolbar">
                    <button type="button" class="btn btn-warning float-right" @click="closeNavLegenda()">
                        <i class="fa fa-times"></i>
                    </button>
                </div>
            </div>
            <div class="card-body" style="color: #111 !important;min-height: 100vh;">
                <h6><b id="legendalayer" class="text-black">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                            Legenda Layer Peta
                        </span>
                        <span v-else>
                            Map Layer Legend
                        </span>
                    </b>
                </h6>
                <ul id="treelegenda" style="cursor: pointer;font-size: small !important;" class="text-black">
                </ul>
            </div>
            <!-- /.card-header -->
        </div>
    </div>
    <div id="mySidenavPengaturan" class="sidenav p-0" style="background-color: #ffffff;">
        <div class="card card-warning shadow-none">
            <div class="card-header" style="background-color: #005c95 !important;color: #ffffff;">
                <h3 class="card-title text-white">Base Map</h3>
                <!-- /.card-tools -->
                <div class="card-toolbar">
                    <button type="button" class="btn btn-warning float-right" @click="closeNavPengaturan()">
                        <i class="fa fa-times"></i>
                    </button>
                </div>
            </div>
            <div class="card-body text-black" style="min-height: 100vh;">
                <h6 class="text-black"><b id="pengeturan">Pengaturan Base Map</b></h6>
                <div class="custom-control custom-radio">
                    <input class="custom-control-input custom-control-input-warning" type="radio" id="customRadio111"
                        name="customRadio" value="1" @click="tampilbasemap('customRadio111')">
                    <label for="customRadio111" class="custom-control-label" style="color: #000000;">Google Map
                        (ROADMAP)</label>
                </div>
                <div class="custom-control custom-radio">
                    <input class="custom-control-input custom-control-input-warning" type="radio" id="customRadio6"
                        name="customRadio" value="6" @click="tampilbasemap('customRadio6')">
                    <label for="customRadio6" class="custom-control-label" style="color: #000000;">Google Map
                        (Hybrid)</label>
                </div>
                <div class="custom-control custom-radio">
                    <input class="custom-control-input custom-control-input-warning" type="radio" id="customRadio8"
                        name="customRadio" value="8" @click="tampilbasemap('customRadio8')">
                    <label for="customRadio8" class="custom-control-label" style="color: #000000;">Google Map
                        (Terrain)</label>
                </div>
                <div class="custom-control custom-radio">
                    <input class="custom-control-input custom-control-input-warning" type="radio" id="customRadio22"
                        name="customRadio" value="2" @click="tampilbasemap('customRadio22')" checked="checked">
                    <label for="customRadio22" class="custom-control-label" style="color: #000000;">MapQuest OSM</label>
                </div>
                <div class="custom-control custom-radio">
                    <input class="custom-control-input custom-control-input-warning" type="radio" id="customRadio4"
                        name="customRadio" value="4" @click="tampilbasemap('customRadio4')">
                    <label for="customRadio4" class="custom-control-label" style="color: #000000;">Esri World Topo
                        Map</label>
                </div>
                <div class="custom-control custom-radio">
                    <input class="custom-control-input custom-control-input-warning" type="radio" id="customRadio9"
                        name="customRadio" value="9" @click="tampilbasemap('customRadio9')">
                    <label for="customRadio9" class="custom-control-label" style="color: #000000;">ESRI World
                        Imagery</label>
                </div>
                <div class="custom-control custom-radio">
                    <input class="custom-control-input custom-control-input-warning" type="radio" id="customRadio10"
                        name="customRadio" value="10" @click="tampilbasemap('customRadio10')">
                    <label for="customRadio10" class="custom-control-label" style="color: #000000;">ESRI World Street
                        Map</label>
                </div>
                <div class="custom-control custom-radio">
                    <input class="custom-control-input custom-control-input-warning" type="radio" id="customRadio11"
                        name="customRadio" value="11" @click="tampilbasemap('customRadio11')">
                    <label for="customRadio11" class="custom-control-label" style="color: #000000;">ESRI Gray
                        Map</label>
                </div>
            </div>
            <!-- /.card-header -->
        </div>
    </div>
    <div id="mySidenavLayer" class="sidenav p-0">
        <div class="card card-warning shadow-none">
            <div class="card-header" style="background-color: #005c95 !important;color: #ffffff;">
                <h3 class="card-title text-white">
                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                        Layer
                    </span>
                    <span v-else>
                        Layers
                    </span>
                </h3>
                <!-- /.card-tools -->
                <div class="card-toolbar">
                    <button type="button" class="btn btn-warning float-right" @click="closeNavLayer()"><i
                            class="fa fa-times"></i></button>
                </div>
            </div>
            <!-- /.card-header -->
            <div class="card-body" style="color: #4e5256 !important;min-height: 100vh;">
                <h6><b id="judultransparant" class="text-black">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                            Transparansi Layer
                        </span>
                        <span v-else>
                            Layer Transparency
                        </span>
                    </b></h6>
                <input id="opacity-input" type="range" min="0" max="1" step="0.01" value="0.75" style="width: 100%;"
                    class="accent" /><span id="opacity-output" style="display: none;"></span>
                <h6><b id="daftarlayer" class="text-black">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                            Daftar Layer
                        </span>
                        <span v-else>
                            List of Layers
                        </span>
                    </b></h6>
                <div class="col-sm-12 float-left pb-2" style="display: none;">
                    <div class="input-group mb-3" v-if="(bahasa === null) || (bahasa == 'ina')">
                        <input id="carikata" placeholder="Masukkan Kata Kunci Pencarian Layer" type="text"
                            class="form-control form-control-sm" style="font-size: small !important;"
                            @change="ambildata()">
                        <div class="input-group-append">
                            <span class="input-group-text" @click="ambildata()" style="cursor: pointer;"><i
                                    class="fas fa-search"></i></span>
                        </div>
                    </div>
                    <div class="input-group mb-3" v-else>
                        <input id="carikata" placeholder="Enter Layer Search Keywords" type="text"
                            class="form-control form-control-sm" style="font-size: small !important;"
                            @change="ambildata()">
                        <div class="input-group-append">
                            <span class="input-group-text" @click="ambildata()" style="cursor: pointer;"><i
                                    class="fas fa-search"></i></span>
                        </div>
                    </div>
                </div>
                <ul id="tree1" style="cursor: pointer;font-size: small !important;">
                </ul>
            </div>
        </div>
    </div>
    <div id="myInfoLayer" class="sidenavkanan p-0">
        <div class="card card-warning shadow-none">
            <div class="card-header" style="background-color: #005c95 !important;color: #ffffff;">
                <h3 class="card-title text-white">Info</h3>
                <!-- /.card-tools -->
                <div class="card-toolbar">
                    <button type="button" class="btn btn-warning float-right" @click="closeNavInfo()"><i
                            class="fa fa-times"></i></button>
                </div>
            </div>
            <!-- /.card-header -->
            <div class="card-body text-center" id="exceldata">
                <button type="button" class="btn btn-success btn-sm text-white lebar2" data-toggle="tooltip"
                    data-placement="left" title="Unduh excel.." @click="G_tableCSVTabel1('_Keterangan_')">
                    <i class="fas fa-download"></i>
                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                        Unduh Keterangan (.xlsx)
                    </span>
                    <span v-else>
                        Download Description (.xlsx)
                    </span>
                </button>
            </div>
            <div class="card-body" style="color: black !important;min-height: 95vh;width: 90%; overflow: auto;"
                id="Info_Adit">
            </div>
        </div>
    </div>
    <Top />
    <!-- Spinner Start -->
    <div id="spinner" v-if="halamanloading"
        class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
        style="opacity: 0.5;">
        <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        &nbsp;<img src="../../../../src/assets/img/BerandaNgumahLogo.png" height="40">
        &nbsp;<span class="text-danger">..Loading...</span>
    </div>
    <!-- Spinner End -->
    <!-- Header Start -->
    <div class="modal fade" id="costumModalkurva" data-easein="flipBounceYIn" tabindex="-1" role="dialog"
        aria-labelledby="costumModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false"
        style="background: rgba(240, 248, 255, 0.1);width: 98vw;height: 98%;">
        <div class="modal-dialog modal-fullscreen">
            <div class="modal-content" style="height: auto;min-width: 90vw; min-height: 98%;">
                <div class="modal-header">
                    <h4 class="modal-title">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                            Informasi
                        </span>
                        <span v-else>
                            Information
                        </span>
                    </h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body text-center"
                    style="height: auto;min-width: 90vw; min-height: 98%;overflow: auto;">
                    <div class="row text-center">
                        <div class="row">
                            <div class="col-sm-12 text-center">
                                <button type="button" class="btn btn-success btn-sm text-white lebar2"
                                    data-toggle="tooltip" data-placement="left" title="Unduh excel.."
                                    @click="eksportexcel()">
                                    <i class="fas fa-download"></i>
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Unduh Data .xlsx
                                    </span>
                                    <span v-else>
                                        Download Data .xlsx
                                    </span>
                                </button>
                            </div>
                            <div class="col-sm-12 text-center">&nbsp;</div>
                            <div class="col-sm-12 text-center">
                                <label>
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')" class="hitam">
                                        dari minggu ke&nbsp;
                                    </span>
                                    <span v-else class="hitam">
                                        from week&nbsp;
                                    </span>
                                </label>
                                <select v-model="awalminggunya" @change="ambiltanggalawalterpilih($event)">
                                    <option v-for="index in akhirminggu" :key="index">
                                        {{ index }}
                                    </option>
                                </select>
                                &nbsp;
                                <label>
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')" class="hitam">
                                        ke minggu ke&nbsp;
                                    </span>
                                    <span v-else class="hitam">
                                        to week&nbsp;
                                    </span>
                                </label>
                                <select v-model="akhirminggunya" @change="ambiltanggalterpilih($event)">
                                    <option v-for="index in akhirminggu" :key="index">
                                        {{ index }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-sm-12 text-center">
                                <LineChartMonitoringProyek1 type="line" :options="chartOptionsmonitoring1"
                                    :series="seriesmonitoring1" height="500">
                                </LineChartMonitoringProyek1>
                            </div>
                            <div class="col-sm-12 text-center">
                                <label>
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">PROGRES REALISASI FISIK</span>
                                    <span v-else>PHYSICAL REALIZATION PROGRESS</span>
                                </label>
                                <div class="table-responsive table-wrapper">
                                    <table class="table m-0" id="tabeldata11" style="font-size: smaller;">
                                        <thead>
                                            <tr>
                                                <th style="width: 50px;">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        Minggu ke-
                                                    </span>
                                                    <span v-else>
                                                        Week to-
                                                    </span>
                                                </th>
                                                <template v-for="(datalist, urutlist) in tempjudul" :key="urutlist">
                                                    <th style="width: 50px;">
                                                        {{ datalist }}
                                                    </th>
                                                </template>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        Rencana
                                                    </span>
                                                    <span v-else>
                                                        Plan
                                                    </span>
                                                </td>
                                                <template v-for="(datalist, urutlist) in temprencanafisik"
                                                    :key="urutlist">
                                                    <td class="text-center">
                                                        {{ datalist }}
                                                    </td>
                                                </template>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        Realisasi
                                                    </span>
                                                    <span v-else>
                                                        Realization
                                                    </span>
                                                </td>
                                                <template v-for="(datalist, urutlist) in temprealisasifisik"
                                                    :key="urutlist">
                                                    <td class="text-center">
                                                        {{ datalist }}
                                                    </td>
                                                </template>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        Deviasi
                                                    </span>
                                                    <span v-else>
                                                        Deviation
                                                    </span>
                                                </td>
                                                <template v-for="(datalist, urutlist) in tempdeviasifisik"
                                                    :key="urutlist">
                                                    <td class="text-center">
                                                        {{ datalist }}
                                                    </td>
                                                </template>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="col-sm-12 text-center">
                                <label>
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">PROGRES REALISASI
                                        KEUANGAN</span>
                                    <span v-else>FINANCIAL REALIZATION PROGRESS</span>
                                </label>
                                <div class="table-responsive table-wrapper">
                                    <table class="table m-0" id="tabeldata11" style="font-size: smaller;">
                                        <thead>
                                            <tr>
                                                <th style="width: 50px;">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        Minggu ke-
                                                    </span>
                                                    <span v-else>
                                                        Week to-
                                                    </span>
                                                </th>
                                                <template v-for="(datalist, urutlist) in tempjudul" :key="urutlist">
                                                    <th style="width: 50px;">
                                                        {{ datalist }}
                                                    </th>
                                                </template>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        Rencana
                                                    </span>
                                                    <span v-else>
                                                        Plan
                                                    </span>
                                                </td>
                                                <template v-for="(datalist, urutlist) in temprencanakeu"
                                                    :key="urutlist">
                                                    <td class="text-center">
                                                        {{ G_numKoma(datalist) }}
                                                    </td>
                                                </template>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        Realisasi
                                                    </span>
                                                    <span v-else>
                                                        Realization
                                                    </span>
                                                </td>
                                                <template v-for="(datalist, urutlist) in temprealisasikeu"
                                                    :key="urutlist">
                                                    <td class="text-center">
                                                        {{ G_numKoma(datalist) }}
                                                    </td>
                                                </template>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        Deviasi
                                                    </span>
                                                    <span v-else>
                                                        Deviation
                                                    </span>
                                                </td>
                                                <template v-for="(datalist, urutlist) in tempdeviasikeu"
                                                    :key="urutlist">
                                                    <td class="text-center">
                                                        {{ G_numKoma(datalist) }}
                                                    </td>
                                                </template>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="col-sm-6 text-center">
                                <label>
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">DATA TEKNIS KEGIATAN</span>
                                    <span v-else>TECHNICAL DATA OF ACTIVITIES</span>
                                </label>
                                <div class="table-responsive table-wrapper">
                                    <table class="table m-0" id="tabeldata5" style="font-size: smaller;">
                                        <thead>
                                            <tr>
                                                <th style="width: 50px;">No</th>
                                                <th style="width: 100px;"><span
                                                        v-if="(bahasa === null) || (bahasa == 'ina')">Informasi</span>
                                                    <span v-else>Information</span>
                                                </th>
                                                <th style="width: 100px;"><span
                                                        v-if="(bahasa === null) || (bahasa == 'ina')">Data</span>
                                                    <span v-else>Data</span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td class="text-center">
                                                    1
                                                </td>
                                                <td class="text-left">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Lokasi</span>
                                                    <span v-else>Location</span>
                                                </td>
                                                <td class="text-left">
                                                    {{ Lokasi }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="text-center">
                                                    2
                                                </td>
                                                <td class="text-left">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Tanggal NOL
                                                        AWP</span>
                                                    <span v-else>AWP NOL Date</span>
                                                </td>
                                                <td class="text-left">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">{{
                                                        G_formatDateNonWIB(tanggal1) }}</span>
                                                    <span v-else>{{ G_formatDateNonWIBEng(tanggal1) }}</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="text-center">
                                                    3
                                                </td>
                                                <td class="text-left">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Tanggal NOL
                                                        RC</span>
                                                    <span v-else>RC NOL Date</span>
                                                </td>
                                                <td class="text-left">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">{{
                                                        G_formatDateNonWIB(tanggal2) }}</span>
                                                    <span v-else>{{ G_formatDateNonWIBEng(tanggal2) }}</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="text-center">
                                                    4
                                                </td>
                                                <td class="text-left">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Anggaran
                                                        AWP</span>
                                                    <span v-else>AWP Budget</span>
                                                </td>
                                                <td class="text-left">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">{{
                                                        G_numFormat(AWP) }}</span>
                                                    <span v-else>{{ G_numFormat(AWP) }}</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="text-center">
                                                    5
                                                </td>
                                                <td class="text-left">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Nilai
                                                        Kontrak</span>
                                                    <span v-else>Contract Value</span>
                                                </td>
                                                <td class="text-left">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">{{
                                                        G_numFormat(NILAIKONTRAK) }}</span>
                                                    <span v-else>{{ G_numFormat(NILAIKONTRAK) }}</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="text-center">
                                                    6
                                                </td>
                                                <td class="text-left">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Tanggal
                                                        Kontrak</span>
                                                    <span v-else>Contract Date</span>
                                                </td>
                                                <td class="text-left">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">{{
                                                        G_formatDateNonWIB(MULAI) }}</span>
                                                    <span v-else>{{ G_formatDateNonWIBEng(MULAI) }}</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="text-center">
                                                    7
                                                </td>
                                                <td class="text-left">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Selesai
                                                        Kontrak</span>
                                                    <span v-else>End of contract</span>
                                                </td>
                                                <td class="text-left">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">{{
                                                        G_formatDateNonWIB(SELESAI) }}</span>
                                                    <span v-else>{{ G_formatDateNonWIBEng(SELESAI) }}</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="text-center">
                                                    8
                                                </td>
                                                <td class="text-left">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Rekanan</span>
                                                    <span v-else>Partner</span>
                                                </td>
                                                <td class="text-left">
                                                    {{ KONTRAKTOR }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="text-center">
                                                    9
                                                </td>
                                                <td class="text-left">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Adendum</span>
                                                    <span v-else>Addendum</span>
                                                </td>
                                                <td class="text-left">
                                                    {{ ADENDUM }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="col-sm-6 text-center">
                                <label>
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">DOKUMENTASI <span
                                            v-if="foto_mingguke != ''">MINGGU KE- {{
                                                foto_mingguke }}</span> </span>
                                    <span v-else>DOCUMENTATION <span v-if="foto_mingguke != ''">WEEK - {{ foto_mingguke
                                            }}</span></span>
                                </label><br></br>
                                <img :src="foto" class="img-fluid gambar" style="height: 300px;">
                                <br></br>
                            </div>
                            <div class="col-sm-12 text-center">&nbsp;<br></br>&nbsp;</div>
                            <div class="col-sm-12 text-center">
                                <div class="table-responsive table-wrapper">
                                    <table class="table m-0" id="tabeldata6" style="font-size: smaller;">
                                        <thead>
                                            <tr>
                                                <th style="width: 100px;"><span
                                                        v-if="(bahasa === null) || (bahasa == 'ina')">Kendala</span>
                                                    <span v-else>Constraint</span>
                                                </th>
                                                <th style="width: 100px;"><span
                                                        v-if="(bahasa === null) || (bahasa == 'ina')">Tindak
                                                        Lanjut</span>
                                                    <span v-else>Follow-up</span>
                                                </th>
                                                <th style="width: 300px;"><span
                                                        v-if="(bahasa === null) || (bahasa == 'ina')">Target Waktu Dan
                                                        Penanggungjawab</span>
                                                    <span v-else>Time Target and Responsible Implementation Unit</span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(datalist, urutlist) in kendalaarray" :key="urutlist">
                                                <td class="text-left">
                                                    <span v-html="Dekriptext(datalist.kendala)"></span>
                                                </td>
                                                <td class="text-left">
                                                    <span v-html="Dekriptext(datalist.tindaklanjut)"></span>
                                                </td>
                                                <td class="text-left">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        {{ G_formatDateNonWIB(datalist.target_penyelesaian) }}
                                                    </span>
                                                    <span v-else>
                                                        {{ G_formatDateNonWIBEng(datalist.target_penyelesaian) }}
                                                    </span>

                                                    , {{ datalist.penanggungjawab }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-center">
                    <div class="row">
                        <div class="col-sm-12 text-center">
                            <button class="btn btn-danger2 text-white" placeholder="Tutup" data-toggle="tooltip"
                                data-placement="left" title="Tutup.." style="color: black;" @click="tutupmodalkurvas()">
                                <b>
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Tutup
                                    </span>
                                    <span v-else>
                                        Close
                                    </span>
                                </b>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="costumModalgaleri" data-easein="flipBounceYIn" tabindex="-1" role="dialog"
        aria-labelledby="costumModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false"
        style="background: rgba(240, 248, 255, 0.1);width: 98vw;height: 98%;">
        <div class="modal-dialog modal-fullscreen">
            <div class="modal-content" style="height: auto;min-width: 90vw; min-height: 98%;">
                <div class="modal-header">
                    <h4 class="modal-title">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                            Daftar Galeri
                        </span>
                        <span v-else>
                            Gallery List
                        </span>
                    </h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body text-center"
                    style="height: auto;min-width: 90vw; min-height: 70vh !important;overflow: auto;height: 70vh !important;">
                    <div class="row text-center">
                        <div class="row">
                            <div class="col-sm-12 text-center">
                                <div class="table-responsive table-wrapper">
                                    <table class="table m-0" id="tabelgaleriadi" style="font-size: small;">
                                        <thead>
                                            <tr>
                                                <th style="width: 50px;">No</th>
                                                <th style="width: 100px;">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        Galeri
                                                    </span>
                                                    <span v-else>
                                                        Gallery
                                                    </span>
                                                </th>
                                                <th style="width: 700px;">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        Info
                                                    </span>
                                                    <span v-else>
                                                        Information
                                                    </span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <template v-for="(datagaleri, urutgaleri) in galeri" :key="urutgaleri">
                                            <tbody>
                                                <tr>
                                                    <td class="text-center">
                                                        {{ (urutgaleri + 1) }}
                                                    </td>
                                                    <td class="text-center">
                                                        <img :src="folder_foto + datagaleri.file_name"
                                                            v-if="datagaleri.file_name.substr(datagaleri.file_name.length - 1) != '4'"
                                                            class="img-size-75 animation__wobble imagegaleri"
                                                            style="height: 100px;cursor: pointer;"
                                                            title="klik untuk memperbesar gambar" :id="datagaleri.id"
                                                            :alt="datagaleri.nama + '#' + datagaleri.nama_eng"
                                                            @click="ambilgambar(datagaleri.id)">
                                                        <video width="200" id="myVideo" controls
                                                            v-if="datagaleri.file_name.substr(datagaleri.file_name.length - 1) == '4'">
                                                            <source :src="folder_foto + datagaleri.file_name"
                                                                type="video/mp4">
                                                            Your browser does not support HTML video.
                                                        </video>
                                                    </td>
                                                    <td class="text-justify">
                                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                            {{ datagaleri.nama }}
                                                        </span>
                                                        <span v-else>
                                                            {{ datagaleri.nama_eng }}
                                                        </span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-center">
                    <div class="row">
                        <div class="col-sm-12 text-center">
                            <button class="btn btn-danger2 text-white" placeholder="Tutup" data-toggle="tooltip"
                                data-placement="left" title="Tutup.." style="color: black;" @click="tutupmodalgaleri()">
                                <b>
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Tutup
                                    </span>
                                    <span v-else>
                                        Close
                                    </span>
                                </b>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="costumModaldokumen" data-easein="flipBounceYIn" tabindex="-1" role="dialog"
        aria-labelledby="costumModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false"
        style="background: rgba(240, 248, 255, 0.1);width: 98vw;height: 98%;">
        <div class="modal-dialog modal-fullscreen">
            <div class="modal-content" style="height: auto;min-width: 90vw; min-height: 98% !important;">
                <div class="modal-header">
                    <h4 class="modal-title">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                            Daftar Dokumen
                        </span>
                        <span v-else>
                            Document List
                        </span>
                    </h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body text-center"
                    style="height: auto;min-width: 90vw; min-height: 70vh !important;overflow: auto;height: 70vh !important;">
                    <div class="row text-center">
                        <div class="row">
                            <div class="col-sm-12 text-center">
                                <div class="table-responsive table-wrapper">
                                    <table class="table m-0" id="tabeldokumenadi" style="font-size: small;">
                                        <thead>
                                            <tr>
                                                <th style="width: 50px;">No</th>
                                                <th style="width: 600px;">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        Dokumen
                                                    </span>
                                                    <span v-else>
                                                        Document
                                                    </span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <template v-for="(datadokumen, urutdokumen) in dokumen" :key="urutdokumen">
                                            <tbody>
                                                <tr>
                                                    <td class="text-center">
                                                        {{ (urutdokumen + 1) }}
                                                    </td>
                                                    <td class="text-justify">
                                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                            <a :href="folder_dokumen + datadokumen.file_name"
                                                                target="_blank">{{
                                                                    datadokumen.nama }}</a>
                                                        </span>
                                                        <span v-else>
                                                            <a :href="folder_dokumen + datadokumen.file_name"
                                                                target="_blank">{{
                                                                    datadokumen.nama_eng }}</a>
                                                        </span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-center">
                    <div class="row">
                        <div class="col-sm-12 text-center">
                            <button class="btn btn-danger2 text-white" placeholder="Tutup" data-toggle="tooltip"
                                data-placement="left" title="Tutup.." style="color: black;"
                                @click="tutupmodaldokumen()">
                                <b>
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Tutup
                                    </span>
                                    <span v-else>
                                        Close
                                    </span>
                                </b>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="costumModalresume" data-easein="flipBounceYIn" tabindex="-1" role="dialog"
        aria-labelledby="costumModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false"
        style="background: rgba(240, 248, 255, 0.1);width: 98vw;height: 98%;">
        <div class="modal-dialog modal-fullscreen">
            <div class="modal-content" style="height: auto;min-width: 90vw; min-height: 98%;">
                <div class="modal-header">
                    <h4 class="modal-title">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                            Resume Proyek
                        </span>
                        <span v-else>
                            Project Resume
                        </span>
                    </h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body text-justify" style="height: auto;min-width: 90vw; min-height: 98%;">
                    <div class="col-sm-12">
                        <br></br>
                        <div class="section-title mb-5">
                            <div class="sub-style">
                                <h5 class="sub-title px-3 mb-0 labelpmis" v-if="(bahasa === null) || (bahasa == 'ina')">
                                    Tanggal Data: {{ G_formatDateNonWIB(tanggaldatamonev) }}
                                </h5>
                                <h5 class="sub-title px-3 mb-0 labelpmis" v-else>
                                    Data Date: {{ G_formatDateNonWIBEng(tanggaldatamonev) }}
                                </h5>
                            </div>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-sm-12 text-center">
                            <div class="card card-navy collapsed-card">
                                <div class="card-header border-transparent"
                                    style="cursor: pointer;background-color: #005c95 !important;"
                                    data-card-widget="collapse">
                                    <div class="sub-style">
                                        <h1 class="card-title text-white" v-if="(bahasa === null) || (bahasa == 'ina')">
                                            MONITORING PROYEK
                                        </h1>
                                        <h1 class="card-title text-white" v-else>
                                            PROJECT MONITORING
                                        </h1>
                                    </div>
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-plus"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body p-3">
                                    <div class="row g-4 justify-content-center">
                                        <div class="col-sm-4">
                                            <DonutsChartMonitoringWaktuProyek type="donut" :options="chartOptionswaktu"
                                                :series="serieswaktu" height="400">
                                            </DonutsChartMonitoringWaktuProyek>
                                        </div>
                                        <div class="col-sm-4">
                                            <DonutsChartMonitoringProyek type="donut" :options="chartOptionsproyek"
                                                :series="seriesproyek" height="400">
                                            </DonutsChartMonitoringProyek>
                                        </div>
                                        <div class="col-sm-4">
                                            <BarChartMonitoringPVProyekBaru type="bar" :options="chartOptionsbaru"
                                                :series="seriesbaru" height="400">
                                            </BarChartMonitoringPVProyekBaru>
                                        </div>
                                        <div class="col-sm-12 text-center">
                                            <div class="section-title mb-5" data-wow-delay="0.1s"
                                                style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
                                                <div class="sub-style">
                                                    <h5 class="sub-title px-3 mb-0 labelpmis"
                                                        v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        Monitoring Jumlah Paket
                                                    </h5>
                                                    <h5 class="sub-title px-3 mb-0 labelpmis" v-else>
                                                        Monitoring Number of Packages
                                                    </h5>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 text-center">
                                            <a class="hitam">
                                                <button type="button" class="btn btn-success btn-sm text-white lebar2"
                                                    data-toggle="tooltip" data-placement="left" title="Unduh excel.."
                                                    @click="G_tableCSVTabelKegiatan('_Rekap_Kegiatan_')">
                                                    <i class="fas fa-download"></i>
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        Unduh Data .xlsx
                                                    </span>
                                                    <span v-else>
                                                        Download Data .xlsx
                                                    </span>
                                                </button>
                                            </a>
                                        </div>
                                        <div class="col-sm-12">
                                            <div class="table-responsive table-wrapper">
                                                <table class="table m-0" id="tabeldata4" style="font-size: smaller;">
                                                    <thead>
                                                        <th style="width: 50px;">No</th>
                                                        <th style="width: 150px;">
                                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                                Paket
                                                            </span>
                                                            <span v-else>
                                                                Package
                                                            </span>
                                                        </th>
                                                        <th style="width: 50px;">OWP (IDR)</th>
                                                        <th style="width: 50px;">
                                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                                Persiapan Pengadaan
                                                            </span>
                                                            <span v-else>
                                                                Procurement Preparation
                                                            </span>
                                                        </th>
                                                        <th style="width: 50px;">
                                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                                Lelang / Tahapan Pengadaan
                                                            </span>
                                                            <span v-else>
                                                                Tender / Procurement Stages
                                                            </span>
                                                        </th>
                                                        <th style="width: 50px;">
                                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                                Terkontrak / Pelaksanaan
                                                            </span>
                                                            <span v-else>
                                                                On Going
                                                            </span>
                                                        </th>
                                                        <th style="width: 50px;">
                                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                                Selesai
                                                            </span>
                                                            <span v-else>
                                                                Completed
                                                            </span>
                                                        </th>
                                                        <th style="width: 50px;">
                                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                                Total
                                                            </span>
                                                            <span v-else>
                                                                Total
                                                            </span>
                                                        </th>
                                                        <th style="width: 50px;">
                                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                                Total terhadap OWP (%)
                                                            </span>
                                                            <span v-else>
                                                                Total to OWP (%)
                                                            </span>
                                                        </th>
                                                    </thead>
                                                    <template v-for="(datalist, urutlist) in dataresume"
                                                        :key="urutlist">
                                                        <tbody>
                                                            <tr>
                                                                <td class="text-center">
                                                                    {{ urutlist + 1 }}
                                                                </td>
                                                                <td class="text-left">
                                                                    {{ datalist.JenisPekerjaan }}
                                                                </td>
                                                                <td class="text-right" :data-v="datalist.OWP"
                                                                    data-z="#,##0.00">
                                                                    {{ G_numFormat(datalist.OWP) }}
                                                                </td>
                                                                <template
                                                                    v-for="(datalistdetail, urutlistdetail) in datalist.detail"
                                                                    :key="urutlistdetail">
                                                                    <td class="text-center"
                                                                        :data-v="datalistdetail.persiapan"
                                                                        data-z="#,##0">
                                                                        {{ G_numFormat(datalistdetail.persiapan) }}
                                                                    </td>
                                                                    <td class="text-center"
                                                                        :data-v="datalistdetail.tender" data-z="#,##0">
                                                                        {{ G_numFormat(datalistdetail.tender) }}
                                                                    </td>
                                                                    <td class="text-center"
                                                                        :data-v="datalistdetail.ongoing" data-z="#,##0">
                                                                        {{ G_numFormat(datalistdetail.ongoing) }}
                                                                    </td>
                                                                    <td class="text-center"
                                                                        :data-v="datalistdetail.finish" data-z="#,##0">
                                                                        {{ G_numFormat(datalistdetail.finish) }}
                                                                    </td>
                                                                </template>
                                                                <td class="text-center" :data-v="datalist.jumlah"
                                                                    data-z="#,##0">
                                                                    {{ G_numFormat(datalist.jumlah) }}
                                                                </td>
                                                                <td class="text-center" :data-v="0" data-z="#,##0.00"
                                                                    v-if="totalowp == 0">
                                                                    0
                                                                </td>
                                                                <td class="text-center"
                                                                    :data-v="(datalist.OWP / totalowp) * 100"
                                                                    data-z="#,##0.00" v-else>
                                                                    {{ G_numFormatKoma((datalist.OWP / totalowp) * 100)
                                                                    }}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </template>
                                                    <template v-for="(datalist, urutlist) in dataresumetotal"
                                                        :key="urutlist">
                                                        <tr>
                                                            <td class="text-center total" colspan="2">
                                                                TOTAL
                                                            </td>
                                                            <td class="totalkanan" :data-v="datalist.OWP"
                                                                data-z="#,##0">
                                                                {{ G_numFormat(datalist.OWP) }}
                                                            </td>
                                                            <template
                                                                v-for="(datalistdetail, urutlistdetail) in datalist.detail"
                                                                :key="urutlistdetail">
                                                                <td class="text-center total"
                                                                    :data-v="datalistdetail.persiapan" data-z="#,##0">
                                                                    {{ G_numFormat(datalistdetail.persiapan) }}
                                                                </td>
                                                                <td class="text-center total"
                                                                    :data-v="datalistdetail.tender" data-z="#,##0">
                                                                    {{ G_numFormat(datalistdetail.tender) }}
                                                                </td>
                                                                <td class="text-center total"
                                                                    :data-v="datalistdetail.ongoing" data-z="#,##0">
                                                                    {{ G_numFormat(datalistdetail.ongoing) }}
                                                                </td>
                                                                <td class="text-center total"
                                                                    :data-v="datalistdetail.finish" data-z="#,##0">
                                                                    {{ G_numFormat(datalistdetail.finish) }}
                                                                </td>
                                                            </template>
                                                            <td class="text-center total">
                                                                {{ G_numFormat(datalist.jumlah) }}
                                                            </td>
                                                            <td class="text-center total" :data-v="0" data-z="#,##0.00"
                                                                v-if="totalowp == 0">
                                                                0
                                                            </td>
                                                            <td class="text-center total"
                                                                :data-v="((datalist.OWP / totalowp) * 100)"
                                                                data-z="#,##0.00" v-else>
                                                                {{ G_numFormatKoma((datalist.OWP / totalowp) * 100) }}
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row g-4 justify-content-center">
                                        <div class="col-sm-12 text-center wow fadeInUp" data-wow-delay="0.1s">
                                            <Bar1ChartMonitoringProyek type="bar" :options="chartOptionsbar1"
                                                :series="seriesbar1" height="350">
                                            </Bar1ChartMonitoringProyek>
                                        </div>
                                    </div>
                                    <div class="row g-4 justify-content-center">
                                        <div class="col-sm-12">
                                            <LineChartMonitoringProyek type="line" :options="chartOptionsmonitoring"
                                                :series="seriesmonitoring" height="500">
                                            </LineChartMonitoringProyek>
                                        </div>
                                    </div>
                                    <div class="row g-4 justify-content-center">
                                        <p>&nbsp;</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card card-navy collapsed-card">
                                <div class="card-header border-transparent"
                                    style="cursor: pointer;background-color: #005c95 !important;"
                                    data-card-widget="collapse">
                                    <div class="sub-style">
                                        <h1 class="card-title text-white" v-if="(bahasa === null) || (bahasa == 'ina')">
                                            MONITORING KOMPONEN DAN SUB KOMPONEN
                                        </h1>
                                        <h1 class="card-title text-white" v-else>
                                            COMPONENT AND SUB-COMPONENT MONITORING
                                        </h1>
                                    </div>
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-plus"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body p-3">
                                    <div class="row g-4 justify-content-center">
                                        <div class="col-sm-12 text-center">
                                            <a class="hitam">
                                                <button type="button" class="btn btn-success btn-sm text-white lebar2"
                                                    data-toggle="tooltip" data-placement="left" title="Unduh excel.."
                                                    @click="G_tableCSVTabelKomponen('_Monitoring_Komponen_')">
                                                    <i class="fas fa-download"></i>
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        Unduh Data .xlsx
                                                    </span>
                                                    <span v-else>
                                                        Download Data .xlsx
                                                    </span>
                                                </button>
                                            </a>
                                        </div>

                                        <div class="col-sm-12">
                                            <div class="table-responsive table-wrapper">
                                                <table class="table m-0" id="tabeldata9"
                                                    style="font-size: 12px !important;">
                                                    <thead>
                                                        <tr>
                                                            <th style="width: 250px;" rowspan="2">
                                                                Component
                                                            </th>
                                                            <th style="width: 250px;" rowspan="2">
                                                                Implementating Agencies
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2">
                                                                OWP
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2">
                                                                <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                                    Disbursement until {{
                                                                        G_formatDateNonWIB(tanggaldatamonev) }}
                                                                </span>
                                                                <span v-else>
                                                                    Disbursement until {{
                                                                        G_formatDateNonWIBEng(tanggaldatamonev) }}
                                                                </span>
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2">
                                                                % to OWP
                                                            </th>
                                                            <th style="width: 50px;" colspan="3">
                                                                Time Elapsed
                                                            </th>
                                                            <th style="width: 50px;display: none;" rowspan="2">
                                                                Progress Variant
                                                            </th>
                                                            <th style="width: 150px;display: none;" rowspan="2">
                                                                Status
                                                            </th>
                                                        </tr>
                                                        <tr>
                                                            <th style="width: 50px;">
                                                                Duration (Month)
                                                            </th>
                                                            <th style="width: 50px;">
                                                                <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                                    Time Passed until {{
                                                                        G_formatDateNonWIB(tanggaldatamonev) }}
                                                                    (Month)
                                                                </span>
                                                                <span v-else>
                                                                    Time Passed until {{
                                                                        G_formatDateNonWIBEng(tanggaldatamonev) }}
                                                                    (Month)
                                                                </span>
                                                            </th>
                                                            <th style="width: 50px;">
                                                                <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                                    Time Remaining (Month)
                                                                </span>
                                                                <span v-else>
                                                                    Time Remaining from (Month)
                                                                </span>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <template v-for="(datalistproyek, urutproyek) in dataproyek"
                                                            :key="urutproyek">
                                                            <td class="text-left total" colspan="2">
                                                                TOTAL
                                                            </td>
                                                            <td class="text-right total">
                                                                {{ G_numFormat(datalistproyek.OWPTOTAL) }}
                                                            </td>
                                                            <td class="text-right total">
                                                                {{ G_numFormat(datalistproyek.Realisasi) }}
                                                            </td>
                                                            <td class="text-right total">
                                                                {{ G_numKoma(datalistproyek.persenkeowp) }}
                                                            </td>
                                                            <td class="text-center total">
                                                                {{ datalistproyek.WaktuLoanBulan }}
                                                            </td>
                                                            <td class="text-center total">
                                                                {{ G_numKoma(datalistproyek.ElapstimeusedBulan) }}
                                                            </td>
                                                            <td class="text-center total">
                                                                {{ G_numKoma(datalistproyek.WaktuLoanBulan -
                                                                    datalistproyek.ElapstimeusedBulan) }}
                                                            </td>
                                                            <td class="text-center total" style="display: none;">
                                                                {{ G_numKoma(datalistproyek.PV) }}
                                                            </td>
                                                            <td class="text-center" style="display: none;"
                                                                :style="'background-color:' + datalistproyek.PVColor">
                                                                {{ datalistproyek.PVStatus }}
                                                            </td>
                                                        </template>
                                                        <template v-for="(datalist, urutlist) in datakomponen"
                                                            :key="urutlist">
                                                            <tr>
                                                                <td class="text-left levelkomponen">
                                                                    {{ datalist.nama }}. {{ datalist.keterangan }}
                                                                </td>
                                                                <td class="text-left levelkomponen">
                                                                    {{ datalist.PIUS }}
                                                                </td>
                                                                <td class="text-right levelkomponen">
                                                                    {{ G_numFormat(datalist.OWP) }}
                                                                </td>
                                                                <td class="text-right levelkomponen">
                                                                    {{ G_numFormat(datalist.REALISASI) }}
                                                                </td>
                                                                <td class="text-center levelkomponen">
                                                                    {{ G_numKoma(datalist.PERSEN) }}
                                                                </td>
                                                                <template
                                                                    v-for="(datalistproyek, urutproyek) in dataproyek"
                                                                    :key="urutproyek">
                                                                    <td class="text-center levelkomponen">
                                                                        {{ datalistproyek.WaktuLoanBulan }}
                                                                    </td>
                                                                    <td class="text-center levelkomponen">
                                                                        {{ G_numKoma(datalistproyek.ElapstimeusedBulan)
                                                                        }}
                                                                    </td>
                                                                    <td class="text-center levelkomponen">
                                                                        {{ G_numKoma(datalistproyek.WaktuLoanBulan -
                                                                            datalistproyek.ElapstimeusedBulan) }}
                                                                    </td>
                                                                </template>
                                                                <td class="text-center levelkomponen" style="display: none;">
                                                                    {{ G_numKoma(datalist.PV) }}
                                                                </td>
                                                                <td class="text-center" style="display: none;"
                                                                    :style="'background-color:' + datalist.WARNA">
                                                                    {{ datalist.STATUS }}
                                                                </td>
                                                            </tr>
                                                            <template
                                                                v-for="(datalistsub, urutlistsub) in datalist.subkomponen"
                                                                :key="urutlistsub">
                                                                <tr>
                                                                    <td class="text-left">
                                                                        {{ datalistsub.nama }}. {{
                                                                            datalistsub.keterangan }}
                                                                    </td>
                                                                    <td class="text-left">
                                                                        {{ datalistsub.PIUS }}
                                                                    </td>
                                                                    <td class="text-right">
                                                                        {{ G_numFormat(datalistsub.OWP) }}
                                                                    </td>
                                                                    <td class="text-right">
                                                                        {{ G_numFormat(datalistsub.REALISASI) }}
                                                                    </td>
                                                                    <td class="text-center">
                                                                        {{ G_numKoma(datalistsub.PERSEN) }}
                                                                    </td>
                                                                    <template
                                                                        v-for="(datalistproyek, urutproyek) in dataproyek"
                                                                        :key="urutproyek">
                                                                        <td class="text-center">
                                                                            {{ datalistproyek.WaktuLoanBulan }}
                                                                        </td>
                                                                        <td class="text-center">
                                                                            {{
                                                                                G_numKoma(datalistproyek.ElapstimeusedBulan)
                                                                            }}
                                                                        </td>
                                                                        <td class="text-center">
                                                                            {{ G_numKoma(datalistproyek.WaktuLoanBulan -
                                                                                datalistproyek.ElapstimeusedBulan) }}
                                                                        </td>
                                                                    </template>
                                                                    <td class="text-center" style="display: none;">
                                                                        {{ G_numKoma(datalistsub.PV) }}
                                                                    </td>
                                                                    <td class="text-center" style="display: none;"
                                                                        :style="'background-color:' + datalistsub.WARNA">
                                                                        {{ datalistsub.STATUS }}
                                                                    </td>
                                                                </tr>
                                                            </template>
                                                        </template>
                                                    </tbody>
                                                    <tbody v-if="(datapesan == 'data kosong')">
                                                        <tr>
                                                            <td colspan="3">Data masih kosong</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row g-4 justify-content-center">
                                        <p>&nbsp;</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card card-navy collapsed-card">
                                <div class="card-header border-transparent"
                                    style="cursor: pointer;background-color: #005c95 !important;"
                                    data-card-widget="collapse">
                                    <div class="sub-style">
                                        <h1 class="card-title text-white" v-if="(bahasa === null) || (bahasa == 'ina')">
                                            REKAPITULASI OWP & AWP
                                        </h1>
                                        <h1 class="card-title text-white" v-else>
                                            RECAPITULATION OWP & AWP
                                        </h1>
                                    </div>
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-plus"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body p-3">
                                    <div class="row g-4 justify-content-center">
                                        <div class="col-sm-12 text-center">
                                            <a class="hitam">
                                                <button type="button" class="btn btn-success btn-sm text-white lebar2"
                                                    data-toggle="tooltip" data-placement="left" title="Unduh excel.."
                                                    @click="G_tableCSVTabelOWPAWP('_Rekap_OWP_AWP_')">
                                                    <i class="fas fa-download"></i>
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        Unduh Data .xlsx
                                                    </span>
                                                    <span v-else>
                                                        Download Data .xlsx
                                                    </span>
                                                </button>
                                            </a>
                                        </div>
                                        <div class="col-sm-12 text-center">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxOWPDetail" value="optionOWPDetail"
                                                    @click="showOWPDetail = !showOWPDetail" checked>
                                                <label for="customCheckboxOWPDetail" class="custom-control-label">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Show
                                                        Satker</span>
                                                    <span v-else>Show Satker</span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <div class="table-responsive table-wrapper">
                                                <table class="table m-0" id="tabeldata2"
                                                    style="font-size: 10px !important;">
                                                    <thead>
                                                        <tr>
                                                            <th style="width: 50px;" rowspan="2">
                                                                No
                                                            </th>
                                                            <th style="width: 250px;" rowspan="2">CPMU / NPIU / CPIU /
                                                                PIU
                                                            </th>
                                                            <th style="width: 100px;" rowspan="2">OWP (IDR)</th>
                                                            <th style="width: 100px;" :colspan="datatahun.length">AWP
                                                                (IDR)
                                                            </th>
                                                            <th style="width: 100px;" rowspan="2">Total<br>AWP<br>(IDR)
                                                            </th>
                                                            <th style="width: 100px;" rowspan="2">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">Sisa<br>Pagu<br>(Rp.)</span>
                                                                <span v-else>Remaining<br>Ceiling<br>(IDR)</span>
                                                            </th>
                                                        </tr>
                                                        <tr>
                                                            <th v-for="(listtahun, uruttahun) in datatahun"
                                                                :key="uruttahun" :data-v="listtahun.tahun"
                                                                data-z="#,##0" style="width: 50px;">
                                                                {{ listtahun.tahun }}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td class="total" colspan="2"> TOTAL</td>
                                                            <td class="totalkanan" :data-v="totalowp" data-z="#,##0.00">
                                                                {{
                                                                    G_numFormat(totalowp)
                                                                }}
                                                            </td>
                                                            <td class="totalkanan"
                                                                v-for="(listtahun, uruttahun) in datatahun"
                                                                :key="uruttahun" data-z="#,##0">
                                                                {{ G_numFormat(listtahun.awppertahun) }}
                                                            </td>
                                                            <td class="totalkanan">
                                                                {{ G_numFormat(totalawp) }}
                                                            </td>
                                                            <td class="totalkanan">
                                                                {{ G_numFormat(sisapagu) }}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                    <template v-for="(datalist, urutlist) in datamaster"
                                                        :key="urutlist">
                                                        <tbody>
                                                            <tr>
                                                                <td data-z="#,##0"
                                                                    :class="[showOWPDetail ? 'levelsubkomponen' : '']">
                                                                    {{ urutlist + 1 }}
                                                                </td>
                                                                <td class="text-left"
                                                                    :class="[showOWPDetail ? 'levelsubkomponen' : '']">
                                                                    {{ datalist.NmSatker }}
                                                                </td>
                                                                <td class="text-right" :data-v="datalist.OWP"
                                                                    data-z="#,##0.00"
                                                                    :class="[showOWPDetail ? 'levelsubkomponen' : '']">
                                                                    {{ G_numFormat(datalist.OWP) }}
                                                                </td>
                                                                <td class="text-right"
                                                                    :class="[showOWPDetail ? 'levelsubkomponen' : '']"
                                                                    v-for="(datalistawp, urutlistawp) in datalist.DetailAWP"
                                                                    :key="urutlistawp" :data-v="datalistawp.AWP"
                                                                    data-z="#,##0.00">
                                                                    {{ G_numFormat(datalistawp.AWP) }}
                                                                </td>
                                                                <td class="text-right" :data-v="datalist.TotalAWP"
                                                                    data-z="#,##0.00"
                                                                    :class="[showOWPDetail ? 'levelsubkomponen' : '']">
                                                                    {{ G_numFormat(datalist.TotalAWP) }}
                                                                </td>
                                                                <td class="text-right" :data-v="datalist.SisaPagu"
                                                                    data-z="#,##0.00"
                                                                    :class="[showOWPDetail ? 'levelsubkomponen' : '']">
                                                                    {{ G_numFormat(datalist.SisaPagu) }}
                                                                </td>
                                                            </tr>
                                                            <tr v-for="(dataSatker, urutSatker) in datalist.Satker"
                                                                :key="urutSatker">
                                                                <td data-z="#,##0" v-if="showOWPDetail">
                                                                    {{ urutlist + 1 }}.{{ urutSatker + 1 }}
                                                                </td>
                                                                <td class="text-left" v-if="showOWPDetail">
                                                                    {{ dataSatker.nama_satker }}
                                                                </td>
                                                                <td class="text-right" :data-v="datalist.OWP"
                                                                    data-z="#,##0.00" v-if="showOWPDetail">
                                                                    {{ G_numFormat(dataSatker.OWP) }}
                                                                </td>
                                                                <template
                                                                    v-for="(datadetailSatker, urutdetailSatker) in dataSatker.detailsatker"
                                                                    :key="urutdetailSatker">
                                                                    <td class="text-right"
                                                                        :data-v="datadetailSatker.AWP" data-z="#,##0.00"
                                                                        v-if="showOWPDetail">
                                                                        {{ G_numFormat(datadetailSatker.AWP) }}
                                                                    </td>
                                                                </template>
                                                                <td class="text-right" :data-v="datalist.AWP"
                                                                    data-z="#,##0.00" v-if="showOWPDetail">
                                                                    {{ G_numFormat(dataSatker.AWP) }}
                                                                </td>
                                                                <td class="text-right" :data-v="datalist.SISAPAGU"
                                                                    data-z="#,##0.00" v-if="showOWPDetail">
                                                                    {{ G_numFormat(dataSatker.SISAPAGU) }}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </template>
                                                    <tbody v-if="(datapesan == 'data kosong')">
                                                        <tr>
                                                            <td colspan="3">Data masih kosong</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row g-4 justify-content-center">
                                        <p>&nbsp;</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card card-navy collapsed-card">
                                <div class="card-header border-transparent"
                                    style="cursor: pointer;background-color: #005c95 !important;"
                                    data-card-widget="collapse">
                                    <div class="sub-style">
                                        <h1 class="card-title text-white" v-if="(bahasa === null) || (bahasa == 'ina')">
                                            REKAPITULASI OWP, AWP DAN KEUANGAN
                                        </h1>
                                        <h1 class="card-title text-white" v-else>
                                            RECAPITULATION OF OWP, AWP AND FINANCE
                                        </h1>
                                    </div>
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-plus"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body p-3">
                                    <div class="row g-4 justify-content-center">
                                        <div class="col-sm-12 text-center">
                                            <a class="hitam">
                                                <button type="button" class="btn btn-success btn-sm text-white lebar2"
                                                    data-toggle="tooltip" data-placement="left" title="Unduh excel.."
                                                    @click="G_tableCSVTabel3('_Rekap_AWP_DIPA_REALISASI_')">
                                                    <i class="fas fa-download"></i>
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        Unduh Data .xlsx
                                                    </span>
                                                    <span v-else>
                                                        Download Data .xlsx
                                                    </span>
                                                </button>
                                            </a>
                                        </div>
                                        <div class="col-sm-12 text-center">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxAWPDetail" value="optionAWPDetail"
                                                    @click="showAWPDetail = !showAWPDetail" checked>
                                                <label for="customCheckboxAWPDetail" class="custom-control-label">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Show
                                                        Satker</span>
                                                    <span v-else>Show Satker</span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <div class="table-responsive table-wrapper">
                                                <table class="table m-0" id="tabeldata3"
                                                    style="font-size: 10px !important;">
                                                    <thead>
                                                        <tr>
                                                            <th style="width: 50px;" rowspan="2">No</th>
                                                            <th style="width: 100px;" rowspan="2">CPMU / NPIU / CPIU /
                                                                PIU
                                                            </th>
                                                            <th style="width: 100px;" rowspan="2">OWP (IDR)</th>
                                                            <template v-for="(listtahun, uruttahun) in datatahun"
                                                                :key="uruttahun">
                                                                <th colspan="4" v-if="listtahun.tahun <= tahunsekarang">
                                                                    {{ listtahun.tahun }}
                                                                </th>
                                                            </template>
                                                            <th style="width: 100px;" rowspan="2">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">Total<br>Realisasi<br>(IDR)</span>
                                                                <span v-else>Total<br>Realization<br>(IDR)</span>
                                                            </th>
                                                            <th style="width: 100px;" rowspan="2">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">Persentase<br>Realisasi<br>ke
                                                                    OWP<br></br>(%)</span>
                                                                <span v-else>Percentage of Realization<br>to
                                                                    OWP<br></br>(%)</span>
                                                            </th>
                                                            <th style="width: 100px;" rowspan="2">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">Kategori<br>Pencairan<br>Anggaran</span>
                                                                <span v-else>Disbursement<br>Category<br>Status</span>
                                                            </th>
                                                        </tr>
                                                        <tr>
                                                            <template v-for="(listtahun, uruttahun) in datatahun"
                                                                :key="uruttahun">
                                                                <th style="width: 100px;"
                                                                    v-if="listtahun.tahun <= tahunsekarang">
                                                                    AWP (IDR)</th>
                                                                <th style="width: 100px;"
                                                                    v-if="listtahun.tahun <= tahunsekarang">
                                                                    DIPA (IDR)</th>
                                                                <th style="width: 100px;"
                                                                    v-if="listtahun.tahun <= tahunsekarang">
                                                                    <span
                                                                        v-if="(bahasa === null) || (bahasa == 'ina')">Realisasi<br>(IDR)</span>
                                                                    <span v-else>Realization<br>(IDR)</span>
                                                                </th>
                                                                <th style="width: 10px;"
                                                                    v-if="listtahun.tahun <= tahunsekarang">
                                                                    <span
                                                                        v-if="(bahasa === null) || (bahasa == 'ina')">Persentase<br>Realisasi<br>ke
                                                                        DIPA<br></br>(%)</span>
                                                                    <span v-else>Percentage<br>of Realization<br>to
                                                                        DIPA<br></br>(%)</span>
                                                                </th>
                                                            </template>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td class="total" colspan="2"> TOTAL</td>
                                                            <td class="totalkanan" :data-v="totalowp" data-z="#,##0.00">
                                                                {{
                                                                    G_numFormat(totalowp)
                                                                }}
                                                            </td>
                                                            <template v-for="(listtahun, uruttahun) in datatahun"
                                                                :key="uruttahun">
                                                                <td class="totalkanan" data-z="#,##0"
                                                                    :data-v="listtahun.awppertahun"
                                                                    v-if="listtahun.tahun <= tahunsekarang">
                                                                    {{ G_numFormat(listtahun.awppertahun) }}
                                                                </td>
                                                                <td class="totalkanan" data-z="#,##0"
                                                                    :data-v="listtahun.dipa"
                                                                    v-if="listtahun.tahun <= tahunsekarang">
                                                                    {{ G_numFormat(listtahun.dipa) }}
                                                                </td>
                                                                <td class="totalkanan" data-z="#,##0"
                                                                    :data-v="listtahun.realisasi"
                                                                    v-if="listtahun.tahun <= tahunsekarang">
                                                                    {{ G_numFormat(listtahun.realisasi) }}
                                                                </td>
                                                                <td class="totalkanan" data-z="#,##0"
                                                                    :data-v="listtahun.persendipa"
                                                                    v-if="listtahun.tahun <= tahunsekarang">
                                                                    {{ G_numKoma(listtahun.persendipa) }}
                                                                </td>
                                                            </template>
                                                            <td class="totalkanan" :data-v="Realisasi"
                                                                data-z="#,##0.00">{{
                                                                    G_numFormat(Realisasi)
                                                                }}
                                                            </td>
                                                            <td class="totalkanan" :data-v="PersenOWP"
                                                                data-z="#,##0.00">{{
                                                                    G_numKoma(PersenOWP)
                                                                }}
                                                            </td>
                                                            <td :data-v="PVStatus"
                                                                :style="'background-color:' + ColorPVStatus">
                                                                {{ (PVStatus) }}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                    <template v-for="(datalist, urutlist) in datamaster"
                                                        :key="urutlist">
                                                        <tbody>
                                                            <tr>
                                                                <td data-z="#,##0"
                                                                    :class="[showAWPDetail ? 'levelsubkomponen' : '']">
                                                                    {{ urutlist + 1 }}
                                                                </td>
                                                                <td class="text-left"
                                                                    :class="[showAWPDetail ? 'levelsubkomponen' : '']">
                                                                    {{ datalist.NmSatker }}
                                                                </td>
                                                                <td class="text-right" :data-v="datalist.OWP"
                                                                    data-z="#,##0.00"
                                                                    :class="[showAWPDetail ? 'levelsubkomponen' : '']">
                                                                    {{ G_numFormat(datalist.OWP) }}
                                                                </td>
                                                                <template
                                                                    v-for="(datalistawp, urutlistawp) in datalist.DetailAWP"
                                                                    :key="urutlistawp">
                                                                    <td class="text-right"
                                                                        :class="[showAWPDetail ? 'levelsubkomponen' : '']"
                                                                        :data-v="datalistawp.AWP"
                                                                        v-if="datalistawp.tahun <= tahunsekarang"
                                                                        data-z="#,##0.00">
                                                                        {{ G_numFormat(datalistawp.AWP) }}
                                                                    </td>
                                                                    <td class="text-right"
                                                                        :class="[showAWPDetail ? 'levelsubkomponen' : '']"
                                                                        :data-v="datalistawp.DIPA"
                                                                        v-if="datalistawp.tahun <= tahunsekarang"
                                                                        data-z="#,##0.00">
                                                                        {{ G_numFormat(datalistawp.DIPA) }}
                                                                    </td>
                                                                    <td class="text-right"
                                                                        :class="[showAWPDetail ? 'levelsubkomponen' : '']"
                                                                        :data-v="datalistawp.REALISASI"
                                                                        v-if="datalistawp.tahun <= tahunsekarang"
                                                                        data-z="#,##0.00">
                                                                        {{ G_numFormat(datalistawp.REALISASI) }}
                                                                    </td>
                                                                    <td class="text-right"
                                                                        :class="[showAWPDetail ? 'levelsubkomponen' : '']"
                                                                        :data-v="datalistawp.persendipa"
                                                                        v-if="datalistawp.tahun <= tahunsekarang"
                                                                        data-z="#,##0.00">
                                                                        {{ G_numKoma(datalistawp.persendipa) }}
                                                                    </td>
                                                                </template>
                                                                <td class="text-right" :data-v="datalist.realisasi"
                                                                    data-z="#,##0.00"
                                                                    :class="[showAWPDetail ? 'levelsubkomponen' : '']">
                                                                    {{ G_numFormat(datalist.realisasi) }}
                                                                </td>
                                                                <td class="text-right" :data-v="datalist.persenkeowp"
                                                                    data-z="#,##0.00"
                                                                    :class="[showAWPDetail ? 'levelsubkomponen' : '']">
                                                                    {{ G_numKoma(datalist.persenkeowp) }}
                                                                </td>
                                                                <td class="text-center" :data-v="datalist.pv"
                                                                    :style="'background-color:' + datalist.warna"
                                                                    :class="[showAWPDetail ? 'levelsubkomponen' : '']">
                                                                    {{ datalist.pv }}
                                                                </td>
                                                            </tr>
                                                            <tr v-for="(dataSatker, urutSatker) in datalist.Satker"
                                                                :key="urutSatker">
                                                                <td data-z="#,##0" v-if="showAWPDetail">
                                                                    {{ urutlist + 1 }}.{{ urutSatker + 1 }}
                                                                </td>
                                                                <td class="text-left" v-if="showAWPDetail">
                                                                    {{ dataSatker.nama_satker }}
                                                                </td>
                                                                <td class="text-right" :data-v="dataSatker.OWP"
                                                                    data-z="#,##0.00" v-if="showAWPDetail">
                                                                    {{ G_numFormat(dataSatker.OWP) }}
                                                                </td>
                                                                <template
                                                                    v-for="(datadetailSatker, urutdetailSatker) in dataSatker.detailsatker"
                                                                    :key="urutdetailSatker">
                                                                    <td class="text-right"
                                                                        :data-v="datadetailSatker.AWP" data-z="#,##0.00"
                                                                        v-if="datadetailSatker.tahun <= tahunsekarang && showAWPDetail">
                                                                        {{ G_numFormat(datadetailSatker.AWP) }}
                                                                    </td>
                                                                    <td class="text-right"
                                                                        :data-v="datadetailSatker.DIPA"
                                                                        data-z="#,##0.00"
                                                                        v-if="datadetailSatker.tahun <= tahunsekarang && showAWPDetail">
                                                                        {{ G_numFormat(datadetailSatker.DIPA) }}
                                                                    </td>
                                                                    <td class="text-right"
                                                                        :data-v="datadetailSatker.REALISASI"
                                                                        data-z="#,##0.00"
                                                                        v-if="datadetailSatker.tahun <= tahunsekarang && showAWPDetail">
                                                                        {{ G_numFormat(datadetailSatker.REALISASI) }}
                                                                    </td>
                                                                    <td class="text-right"
                                                                        :data-v="datadetailSatker.PERSENDIPA"
                                                                        data-z="#,##0.00"
                                                                        v-if="datadetailSatker.tahun <= tahunsekarang && showAWPDetail">
                                                                        {{ G_numKoma(datadetailSatker.PERSENDIPA) }}
                                                                    </td>
                                                                </template>
                                                                <td class="text-right"
                                                                    :data-v="dataSatker.realisasitotal"
                                                                    data-z="#,##0.00" v-if="showAWPDetail">
                                                                    {{ G_numFormat(dataSatker.realisasitotal) }}
                                                                </td>
                                                                <td class="text-right"
                                                                    :data-v="dataSatker.persensatkerowp"
                                                                    data-z="#,##0.00" v-if="showAWPDetail">
                                                                    {{ G_numKoma(dataSatker.persensatkerowp) }}
                                                                </td>
                                                                <td class="text-center" :data-v="dataSatker.pv"
                                                                    :style="'background-color:' + dataSatker.warna"
                                                                    v-if="showAWPDetail">
                                                                    {{ dataSatker.pv }}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </template>
                                                    <tbody v-if="(datapesan == 'data kosong')">
                                                        <tr>
                                                            <td colspan="3">Data masih kosong</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row g-4 justify-content-center">
                                        <p>&nbsp;</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer text-center">
                    <div class="col-sm-12 text-center">
                        <button class="btn btn-danger2 text-white" placeholder="Tutup" data-toggle="tooltip"
                            data-placement="left" title="Tutup.." style="color: black;" @click="tutupmodalresume()">
                            <b>
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                    Tutup
                                </span>
                                <span v-else>
                                    Close
                                </span>
                            </b>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="costumModalunduhdata" data-easein="flipBounceYIn" tabindex="-1" role="dialog"
        aria-labelledby="costumModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false"
        style="background: rgba(240, 248, 255, 0.1);width: 98vw;height: 98%;">
        <div class="modal-dialog modal-fullscreen">
            <div class="modal-content" style="height: auto;min-width: 90vw; min-height: 98%;">
                <div class="modal-header">
                    <h4 class="modal-title">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                            Daftar Layer
                        </span>
                        <span v-else>
                            List of Layers
                        </span>
                    </h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body text-justify" style="height: auto;min-width: 90vw; min-height: 98%;">
                    <div class="col-sm-12">
                        <div class="card cardputih">
                            <div class="card-body p-2">
                                <div class="table-responsive table-wrapper">
                                    <table class="table m-0" id="tabeldataadi" style="font-size: small;">
                                        <thead>
                                            <tr>
                                                <th style="width: 50px;">No</th>
                                                <th style="width: 250px;">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        Nama Data Layer
                                                    </span>
                                                    <span v-else>
                                                        Data Layer Name
                                                    </span>
                                                </th>
                                                <th style="width: 100px;">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        Opsi
                                                    </span>
                                                    <span v-else>
                                                        Option
                                                    </span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <template v-for="(datalist, urutlist) in daftarunduhlayer" :key="urutlist">
                                            <tbody>
                                                <tr>
                                                    <td class="text-center">
                                                        {{ (urutlist + 1) }}
                                                    </td>
                                                    <td class="text-justify">
                                                        {{ datalist.nama }}
                                                    </td>
                                                    <td class="text-center">
                                                        <button type="button"
                                                            class="btn btn-success btn-sm lebar2 text-white"
                                                            @click="prosesdata(datalist.namalayer)"
                                                            data-toggle="tooltip" data-placement="left"
                                                            title="Lihat data.."><i class="fas fa-download"></i>
                                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                                Lihat data
                                                            </span>
                                                            <span v-else>
                                                                View Data
                                                            </span>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </table>
                                </div>
                            </div>
                            <div class="card-footer p-3">

                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12" v-if="(dataunduhlayer.length > 0)">
                        <div class="card cardputih">
                            <div class="card-body p-2 text-center">
                                <button type="button" class="btn btn-success btn-sm lebar2 text-white"
                                    @click="G_tableCSVTabel2('_DetailData_')" data-toggle="tooltip"
                                    data-placement="left" title="Unduh data (.xlsx).."><i class="far fa-file-excel"></i>
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Unduh data (.xlsx)
                                    </span>
                                    <span v-else>
                                        Download Data (.xlsx)
                                    </span>
                                </button><br><br>
                                <span v-show="dataunduhlayer.length == 0">Silahkan Pilih Data .....</span>
                                <center>
                                    <div class="spinner-border text-danger text-center"
                                        style="width: 3rem; height: 3rem;" role="status"
                                        v-show="dataunduhlayer.length == 0">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span v-show="dataunduhlayer.length == 0">Loading Data .....</span>
                                </center>
                                <div class="table-responsive table-wrapper">
                                    <table class="table m-0" id="tabeldataadidata" style="font-size: small;">
                                        <thead>
                                            <tr>
                                                <th style="width: 50px;">No</th>
                                                <template v-for="(datajudul, urutjudul) in datajudulunduhlayer"
                                                    :key="urutjudul">
                                                    <th style="width: 150px;">{{ datajudul }}</th>
                                                </template>
                                            </tr>
                                        </thead>
                                        <template v-for="(datalist, urutlist) in dataunduhlayer" :key="urutlist">
                                            <tbody>
                                                <tr>
                                                    <td class="text-center">
                                                        {{ (urutlist + 1) }}
                                                    </td>
                                                    <td class="text-justify" v-for="(dataisi, urutisi) in datalist"
                                                        :key="urutisi">
                                                        {{ dataisi.data }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </table>
                                </div>
                            </div>
                            <div class="card-footer p-3">

                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer text-center"
                    style="position: fixed;left: 0;bottom: 10px;width: 98%;min-height: 100px;">
                    <div class="col-sm-12 text-center">
                        <button class="btn btn-danger2 text-white" placeholder="Tutup" data-toggle="tooltip"
                            data-placement="left" title="Tutup.." style="color: black;" @click="tutupmodal()">
                            <b>
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                    Tutup
                                </span>
                                <span v-else>
                                    Close
                                </span>
                            </b>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="costumModalinformasidata" data-easein="flipBounceYIn" tabindex="-1" role="dialog"
        aria-labelledby="costumModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false"
        style="background: rgba(240, 248, 255, 0.1);width: 98vw;height: 98%;">
        <div class="modal-dialog modal-fullscreen">
            <div class="modal-content" style="height: auto;min-width: 90vw; min-height: 98%;">
                <div class="modal-header">
                    <h4 class="modal-title">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                            Informasi Data Layer
                        </span>
                        <span v-else>
                            Data Layer Information
                        </span>
                    </h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body text-justify" style="height: auto;min-width: 90vw; min-height: 98%;">
                    <div class="col-sm-12">
                        <div class="card cardputih">
                            <div class="card-body p-2">
                                <div class="table-responsive table-wrapper">
                                    <table class="table m-0" id="tabeldataadi" style="font-size: small;">
                                        <thead>
                                            <tr>
                                                <th style="width: 50px;">No</th>
                                                <th style="width: 250px;">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        Nama Data Layer
                                                    </span>
                                                    <span v-else>
                                                        Data Layer Name
                                                    </span>
                                                </th>
                                                <th style="width: 100px;">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        Opsi
                                                    </span>
                                                    <span v-else>
                                                        Option
                                                    </span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <template v-for="(datalist, urutlist) in daftarunduhlayer" :key="urutlist">
                                            <tbody>
                                                <tr>
                                                    <td class="text-center">
                                                        {{ (urutlist + 1) }}
                                                    </td>
                                                    <td class="text-justify">
                                                        {{ datalist.nama }}
                                                    </td>
                                                    <td class="text-center">
                                                        <button type="button"
                                                            class="btn btn-success btn-sm lebar2 text-white"
                                                            @click="informasidatalayer(datalist.namalayer)"
                                                            data-toggle="tooltip" data-placement="left"
                                                            title="Lihat data.."><i class="fas fa-download"></i>
                                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                                Lihat informasi data
                                                            </span>
                                                            <span v-else>
                                                                View data information
                                                            </span>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </table>
                                </div>
                            </div>
                            <div class="card-footer p-3">

                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12" v-if="(dataunduhlayer.length > 0)">
                        <div class="card cardputih">
                            <div class="card-body p-2 text-center">
                                <button type="button" class="btn btn-success btn-sm lebar2 text-white"
                                    @click="G_tableCSVTabel2('_DetailData_')" data-toggle="tooltip"
                                    data-placement="left" title="Unduh data (.xlsx).."><i class="far fa-file-excel"></i>
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Unduh data (.xlsx)
                                    </span>
                                    <span v-else>
                                        Download Data (.xlsx)
                                    </span>
                                </button><br><br>
                                <span v-show="dataunduhlayer.length == 0">Silahkan Pilih Data .....</span>
                                <center>
                                    <div class="spinner-border text-danger text-center"
                                        style="width: 3rem; height: 3rem;" role="status"
                                        v-show="dataunduhlayer.length == 0">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span v-show="dataunduhlayer.length == 0">Loading Data .....</span>
                                </center>
                                <div class="table-responsive table-wrapper">
                                    <table class="table m-0" id="tabeldataadidata" style="font-size: small;">
                                        <thead>
                                            <tr>
                                                <th style="width: 50px;">No</th>
                                                <template v-for="(datajudul, urutjudul) in datajudulunduhlayer"
                                                    :key="urutjudul">
                                                    <th style="width: 150px;">{{ datajudul }}</th>
                                                </template>
                                            </tr>
                                        </thead>
                                        <template v-for="(datalist, urutlist) in dataunduhlayer" :key="urutlist">
                                            <tbody>
                                                <tr>
                                                    <td class="text-center">
                                                        {{ (urutlist + 1) }}
                                                    </td>
                                                    <td class="text-justify" v-for="(dataisi, urutisi) in datalist"
                                                        :key="urutisi">
                                                        {{ dataisi.data }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </table>
                                </div>
                            </div>
                            <div class="card-footer p-3">

                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer text-center"
                    style="position: fixed;left: 0;bottom: 10px;width: 98%;min-height: 100px;">
                    <div class="col-sm-12 text-center">
                        <button class="btn btn-danger2 text-white" placeholder="Tutup" data-toggle="tooltip"
                            data-placement="left" title="Tutup.." style="color: black;" @click="tutupmodalinformasi()">
                            <b>
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                    Tutup
                                </span>
                                <span v-else>
                                    Close
                                </span>
                            </b>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid">
        &nbsp;
    </div>
    <div class="container-fluid">
        &nbsp;
    </div>
    <div class="container-fluid">
        &nbsp;
    </div>
    <div class="container-fluid">
        &nbsp;
    </div>
    <!-- Header End -->
    <div class="container-fluid py-1 wow fadeInUp" data-wow-delay="0.1s">
    </div>
    <div class="col-sm-12 wow fadeInDown">
        <div class="card cardputih">
            <div class="card-header border-transparent">
                <h5 class="card-title text-black">
                    <b>
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                            Opsi Peta
                        </span>
                        <span v-else>
                            Map Options
                        </span>
                    </b>
                </h5>
                <input type="hidden" id="detaildatamulti" value=""></input>
                <input type="hidden" id="paramlayerunduh" value=""></input>
                <input type="hidden" id="paramlayerinformasi" value=""></input>
                <input type="hidden" id="paramkodecekbox" value=""></input>
                <input type="hidden" id="isidatakosong" value=""></input>
                <button type="button" class="btn btn-tool text-black" data-toggle="tooltip" data-placement="left"
                    title="Parse Data" @click="parsedatalayer()" id="tombolparamunduh" style="display: none;">
                    <i class="far fa-clone"></i> Parse Data
                </button>
                <button type="button" class="btn btn-tool text-black" data-toggle="tooltip" data-placement="left"
                    title="Tes Peta" @click="ceklayer()" id="tombolparamkodecekbox" style="display: none;">
                    <i class="far fa-clone"></i> Tes Peta
                </button>
                <button type="button" class="btn btn-tool text-black" data-toggle="tooltip" data-placement="left"
                    title="Tes Peta" @click="modalfilter()" id="tombolfilterkodecekbox" style="display: none;">
                    <i class="far fa-clone"></i> Filter Peta
                </button>
                <button type="button" class="btn btn-tool text-white" data-toggle="tooltip" data-placement="left"
                    title="Data Kosong" @click="datakosonglayer()" id="tomboldatakosong" style="display: none;">
                    <i class="far fa-clone"></i> Data Kosong
                </button>
                <div class="card-tools">
                    <button type="button" class="btn btn-tool text-black" data-toggle="tooltip" data-placement="left"
                        title="Resume Proyek / Project Resume" @click="bukaresume()" style="color: #000000;">
                        <i class="fas fa-chart-area"></i>
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                            Resume Proyek
                        </span>
                        <span v-else>
                            Project Resume
                        </span>
                    </button>
                    <button type="button" class="btn btn-tool text-black" data-toggle="tooltip" data-placement="left"
                        title="Layer Peta / Map Layers" @click="openNavLayer()" style="color: #000000;">
                        <i class="far fa-clone"></i>
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                            Layer Peta
                        </span>
                        <span v-else>
                            Map Layers
                        </span>
                    </button>
                    <button type="button" class="btn btn-tool text-black" data-toggle="tooltip" data-placement="left"
                        title="Legenda Peta / Map Legend" @click="openNavLegenda()" style="color: #000000;">
                        <i class="fas fa-photo-video"></i>
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                            Legenda Peta
                        </span>
                        <span v-else>
                            Map Legend
                        </span>
                    </button>
                    <button type="button" class="btn btn-tool text-black" data-toggle="tooltip" data-placement="left"
                        title="Informasi Layer Peta / Map Layer Information" @click="cekdataterpilihinformasi()"
                        style="color: #000000;display: none;">
                        <i class="fas fa-align-justify"></i>
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                            Informasi Layer Peta
                        </span>
                        <span v-else>
                            Map Layer Information
                        </span>
                    </button>
                    <button type="button" class="btn btn-tool text-black" data-toggle="tooltip" data-placement="left"
                        title="Unduh Data Tabel Peta / Download Map Table Data" @click="cekdataterpilih()"
                        style="color: #000000;">
                        <i class="fas fa-cloud-download-alt"></i>
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                            Unduh Data Tabel Peta
                        </span>
                        <span v-else>
                            Download Map Table Data
                        </span>
                    </button>
                    <button type="button" class="btn btn-tool text-black" data-toggle="tooltip" data-placement="left"
                        title="Basemap Peta / Map Basemap" @click="openNavPengaturan()" style="color: #000000;">
                        <i class="fas fa-cogs"></i>
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                            Basemap Peta
                        </span>
                        <span v-else>
                            Map Basemap
                        </span>
                    </button>
                    <button type="button" class="btn btn-tool text-black" data-toggle="tooltip" data-placement="left"
                        title="Cetak Peta / Print Map" @click="cetakpeta()" style="color: #000000;">
                        <i class="fas fa-print"></i>
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                            Cetak Peta
                        </span>
                        <span v-else>
                            Print Map
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
        <div id="myModal" class="modal text-center">
        <div class="row text-center">
            <div class="col-sm-12 text-center" style="background-color: #005c95;">
                &nbsp;
            </div>
            <div class="col-sm-12 text-center" style="background-color: #005c95;">
                <button class="closenya">Close</button>
            </div>
            <div class="col-sm-12 text-center" style="background-color: #005c95;">
                &nbsp;
            </div>
            <div class="col-sm-12 text-center">
                <div id="caption" class="col-sm-12 text-center" style="text-transform: uppercase;"></div>
            </div>
            <div class="col-sm-12 text-center">
                &nbsp;
            </div>
            <div class="col-sm-12 text-center" style="display: flex;justify-content: center;align-items: center;">
                <img class="modal-content" id="img01" style="width: 100vw !important;">
            </div>
            <div class="col-sm-12 text-center">
                &nbsp;
            </div>
            <div class="col-sm-12 text-center" style="background-color: #005c95;">
                &nbsp;
            </div>
            <div class="col-sm-12 text-center" style="background-color: #005c95;">
                <button class="closenya2">Close</button>
            </div>
            <div class="col-sm-12 text-center" style="background-color: #005c95;">
                &nbsp;
            </div>
        </div>
    </div>
    <button type="button" id="bukabawah" style="display: none;" class="btn btn-tool text-white" data-toggle="tooltip"
        data-placement="left" title="Buka Bawah" @click="openNavInfoBawah()">
        <i class="fas fa-cogs"></i>
    </button>
    <button type="button" id="bukabawahkec" style="display: none;" class="btn btn-tool text-white" data-toggle="tooltip"
        data-placement="left" title="Buka Bawah" @click="openNavInfoBawahKec()">
        <i class="fas fa-cogs"></i>
    </button>
    <button type="button" id="bukabawahkurva" style="display: none;" class="btn btn-tool text-white"
        data-toggle="tooltip" data-placement="left" title="Buka Bawah" @click="openNavInfoBawahKurva()">
        <i class="fas fa-cogs"></i>
    </button>
    <button type="button" id="bukabawahdesa" style="display: none;" class="btn btn-tool text-white"
        data-toggle="tooltip" data-placement="left" title="Buka Bawah" @click="openNavInfoBawahDesa()">
        <i class="fas fa-cogs"></i>
    </button>
    <input type="hidden" class="form-control" id="linknya" name="linknya" placeholder="linknya" :value="linknya">
    <iframe :src="sourcenya" class="container-fluid wow fadeInUp" style="min-height: 100vh;" frameborder="0" id="maps"
        scrolling="no" @load="loadpeta()">
    </iframe>
    <!-- Header End -->
    <a href="#" class="btn btn-dangerbulet btn-lg-square back-to-top text-white"><i class="fa fa-arrow-up"></i></a>
    <Footer />
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import select2 from 'select2';
import swal from 'sweetalert2';
import vSelect from 'vue-select';
import xlsx from 'xlsx/dist/xlsx.full.min';
import CryptoJS from 'crypto-js';
import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
import { useRoute } from 'vue-router';
import { watch } from 'vue';
import Top from "./Template/Top.vue";
import Footer from "./Template/Footer.vue";

export default {
    setup() {
        const route = useRoute()
        watch(() => route.name, () => {
        });

        return { route };
    },
    components: {
        Top, Footer, swal, BarChartKerjasama: VueApexCharts, vSelect
        , DonutsChartMonitoringProyek: VueApexCharts
        , DonutsChartMonitoringWaktuProyek: VueApexCharts, DonutsChartMonitoringPVProyek: VueApexCharts
        , LineChartMonitoringProyek: VueApexCharts, BarChartMonitoringPVProyek: VueApexCharts
        , BarChartMonitoringPVProyekBaru: VueApexCharts, Bar1ChartMonitoringProyek: VueApexCharts
        , LineChartMonitoringProyek1: VueApexCharts
    },
    data() {
        return {
            halamanloading: true,
            galeri: [],
            dokumen: [],
            datapesan: '',
            showOWPDetail: true,
            showAWPDetail: true,
            datamaster: [],
            carikataalokasi: '',
            showHuman: false,
            tahun: new Date().getFullYear(),
            linknya: process.env.VUE_APP_URL_API,
            bahasa: localStorage.getItem("bahasasistem"),
            tanggalsinkron: new Date(),
            tanggaldatamonev: new Date(),
            project_id: process.env.VUE_APP_PROJECT_ID,
            folder_foto: process.env.VUE_APP_URL_API + 'parastapainnovation_berita-Gambar?f=',
            folder_video: process.env.VUE_APP_URL_API + 'backoffice/upload/pic/',
            folder_dokumen: process.env.VUE_APP_URL_API + 'parastapainnovation_dokumen-File?f=',
            sourcenya: '',
            sourcenyacetak: '',
            secretencData: decodeURIComponent(CryptoJS.AES.decrypt(this.route.params.id, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString(CryptoJS.enc.Utf8)),
            ipnya: '',
            capcha: this.makeid(5), capchainput: "",
            nama: '',
            hp: '',
            keperluan: '',
            tampilmodal: localStorage.getItem("bookstamu"),
            data_layer: [],
            data_legenda: [],
            kabkot: [],
            datakabkot: [],
            defaultSelectedkabkot: {
                code: 0,
                label: 'Semua Kabupaten/Kota',
                tag: '',
            },
            selectedkabkot: '',
            filter: [],
            datafilter: [],
            defaultSelectedfilter: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedfilter: '',
            paramselectedfilter: [],
            arraynamafilter: [],

            textfilenya_peta: false,
            tmpidparameter: '',
            selectedradius: '0',
            iduser: JSON.parse(localStorage.getItem("usistem")),
            daftarunduhlayer: [],
            dataunduhlayer: [],
            datajudulunduhlayer: [],
            carikata: '',
            totalkegiatan: 0,
            totalalokasi: 0,
            selectedtahunalokasi: '',
            selectedkabkotalokasi: '',
            tempjudul: [],
            temprencanafisik: [],
            temprencanakeu: [],
            temprealisasifisik: [],
            temprealisasikeu: [],
            tempdeviasifisik: [],
            tempdeviasikeu: [],
            awalminggu: 0,
            akhirminggu: 0,
            awalminggunya: 0,
            akhirminggunya: 0,
            idnya: '',
            mulainya: '',
            selesainya: '',
            kendalaarray: [],
            foto: '',
            foto_mingguke: '',
            kendala: '',
            tindaklanjut: '',

            datatahun: [],
            dataresume: [],
            dataresumetotal: [],
            totalowp: 0,
            totalawp: 0,
            sisapagu: 0,
            Realisasi: 0,
            PersenOWP: 0,
            PVStatus: '',
            ColorPVStatus: '',
            tahun: new Date().getFullYear(),
            bahasa: localStorage.getItem("bahasasistem"),
            project_id: process.env.VUE_APP_PROJECT_ID,
            tanggalsinkron: new Date(),
            tanggaldatamonev: new Date(),

            seriesbar1: [],
            chartOptionsbar1: {
                title: {
                    text: 'Jumlah Total Kegiatan Dan Jenis Kegiatan',
                    align: 'center'
                },
                chart: {
                    type: 'bar',
                    height: 350,
                    toolbar: {
                        show: true
                    }
                },
                plotOptions: {
                    bar: {
                        dataLabels: {
                            position: 'top', // top, center, bottom
                        },
                        horizontal: false,
                        columnWidth: '55%',
                        endingShape: 'rounded'
                    },
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        return val;
                    },
                    offsetY: -20,
                    style: {
                        fontSize: '12px',
                        colors: ["#304758"]
                    }
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                },
                xaxis: {
                    categories: [],
                },
                yaxis: {
                    title: {
                        text: 'Jumlah Kegiatan'
                    }
                },
                fill: {
                    opacity: 1
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val + " Kegiatan"
                        }
                    }
                }
            },

            dataproyek: [],
            seriesproyek: [],
            chartOptionsproyek: {
                chart: {
                    type: 'donut',
                },

                tooltip: {
                    enabled: true,
                    formatter: function (value) {
                        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                    }
                },
                title: {
                    text: '',
                    align: 'center',
                    margin: 10,
                    offsetX: 0,
                    offsetY: 0,
                    floating: false,
                    style: {
                        fontSize: '14px',
                        fontWeight: 'bold',
                        fontFamily: 'Poppins-SemiBold, Arial',
                        color: '#263238'
                    },
                },
                legend: {
                    show: true,
                    position: 'bottom',
                },
                colors: ['#2176e6', '#ffc107'],
                plotOptions: {
                    pie: {
                        donut: {
                            labels: {
                                show: true,
                                name: {
                                    formatter: function (value) {
                                        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                                    },
                                },
                                value: {
                                    formatter: function (val) {
                                        return (val / 1000000000).toFixed(0).replace('.', ',').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ' M';
                                    }
                                },
                                total: {
                                    formatter: function (w) {
                                        let setTotal = w.globals.seriesTotals.reduce((a, b) => parseFloat(a) + parseFloat(b), 0)
                                        let val = (setTotal / 1000000000000).toFixed(2).replace('.', ',')
                                        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ' T'
                                    },
                                    show: true,
                                },
                            }
                        }
                    }
                },
                labels: [],
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            },

            datawaktu: [],
            serieswaktu: [],
            chartOptionswaktu: {
                chart: {
                    type: 'donut',
                },

                tooltip: {
                    enabled: true,
                    formatter: function (value) {
                        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                    }
                },
                title: {
                    text: '',
                    align: 'center',
                    margin: 10,
                    offsetX: 0,
                    offsetY: 0,
                    floating: false,
                    style: {
                        fontSize: '14px',
                        fontWeight: 'bold',
                        fontFamily: 'Poppins-SemiBold, Arial',
                        color: '#263238'
                    },
                },
                legend: {
                    show: true,
                    position: 'bottom',
                },
                colors: ['#2176e6', '#ffc107'],
                plotOptions: {
                    pie: {
                        donut: {
                            labels: {
                                show: true,
                                name: {
                                    formatter: function (value) {
                                        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                                    },
                                },
                                value: {
                                    formatter: function (val) {
                                        return (val / 1).toFixed(2).replace('.', ',').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ' Bulan';
                                    }
                                },
                                total: {
                                    formatter: function (w) {
                                        let setTotal = w.globals.seriesTotals.reduce((a, b) => parseFloat(a) + parseFloat(b), 0)
                                        let val = (setTotal / 1).toFixed(2).replace('.', ',')
                                        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ' Bulan'
                                    },
                                    show: true,
                                },
                            }
                        }
                    }
                },
                labels: [],
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            },

            datapv: [],
            seriespv: [],
            chartOptionspv: {
                chart: {
                    type: 'donut',
                },

                tooltip: {
                    enabled: true,
                    formatter: function (value) {
                        return parseFloat(value).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                    }
                },
                title: {
                    text: '',
                    align: 'center',
                    margin: 10,
                    offsetX: 0,
                    offsetY: 0,
                    floating: false,
                    style: {
                        fontSize: '14px',
                        fontWeight: 'bold',
                        fontFamily: 'Poppins-SemiBold, Arial',
                        color: '#263238'
                    },
                },
                legend: {
                    show: true,
                    position: 'bottom',
                },
                colors: ['#2176e6', '#ffc107'],
                labels: [],
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            },

            datamonitoring: [],
            seriesmonitoring: [],
            chartOptionsmonitoring: {
                chart: {
                    width: '100%',
                    height: 450,
                    type: 'line',
                    zoom: {
                        type: 'x',
                        enabled: true,
                        autoScaleYaxis: true
                    },
                    toolbar: {
                        autoSelected: 'zoom'
                    }
                },
                colors: ['#00CED1', '#FFD700', '#9370DB', '#4682B4', '#32CD32'],
                dataLabels: {
                    enabled: true,
                },
                stroke: {
                    curve: 'smooth'
                },
                title: {
                    text: 'Average High & Low Temperature',
                    align: 'center'
                },
                grid: {
                    borderColor: '#e7e7e7',
                    row: {
                        colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                        opacity: 0.5
                    },
                },
                markers: {
                    size: 1
                },
                xaxis: {
                    categories: [],
                    title: {
                        text: ''
                    }
                },
                yaxis: {
                    title: {
                        text: ''
                    },
                },
                legend: {
                    position: 'bottom',
                    floating: true,
                    offsetY: -10,
                    offsetX: -100,
                    show: true,
                }
            },

            series_newpv: [{
                data: []
            }],
            chartOptions_newpv: {
                plotOptions: {
                    bar: {
                        barHeight: '100%',
                        distributed: true,
                        horizontal: true,
                        dataLabels: {
                            position: 'bottom'
                        },
                    }
                },
                colors: [],
                dataLabels: {
                    enabled: true,
                    textAnchor: 'start',
                    style: {
                        colors: ['#fff']
                    },
                    formatter: function (val, opt) {
                        return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val
                    },
                    offsetX: 0,
                    dropShadow: {
                        enabled: true
                    }
                },
                stroke: {
                    width: 1,
                    colors: ['#fff']
                },
                xaxis: {
                    categories: ['OCR', 'UK-ACGF TF', 'All'],
                },
                yaxis: {
                    labels: {
                        show: false
                    }
                },
                title: {
                    text: 'Progress Variant',
                    align: 'center',
                    floating: true
                },

                tooltip: {
                    theme: 'dark',
                    x: {
                        show: false
                    },
                    y: {
                        title: {
                            formatter: function () {
                                return ''
                            }
                        }
                    }
                }
            },
            seriesbaru: [],
            chartOptionsbaru: {
                chart: {
                    height: 350,
                    type: 'line',
                    stacked: false,
                },
                annotations: {
                    yaxis: [{
                        y: 1,
                        strokeDashArray: 2,
                        width: '100%',
                        borderColor: '#90EE90',
                        label: {
                            borderColor: '#90EE90',
                            style: {
                                fontSize: '11px',
                                color: '#333',
                                background: '#90EE90',
                            },
                            text: 'ON SCHEDULE',
                        },
                    }, {
                        y: 0.999,
                        strokeDashArray: 2,
                        width: '100%',
                        borderColor: '#90EE90',
                    }, {
                        y: 1.009,
                        strokeDashArray: 2,
                        width: '100%',
                        borderColor: '#90EE90',
                    }, {
                        y: 0.3,
                        strokeDashArray: 2,
                        borderColor: '#B22222',
                        label: {
                            borderColor: '#B22222',
                            style: {
                                fontSize: '11px',
                                color: '#ffffff',
                                background: '#B22222',
                            },
                            text: 'AT RISK <=0,3',
                        },
                    }, {
                        y: 0.2999,
                        strokeDashArray: 2,
                        borderColor: '#B22222',

                    }, {
                        y: 0.3111,
                        strokeDashArray: 2,
                        borderColor: '#B22222',

                    }],
                },

                stroke: {
                    width: [5, 5, 5, 5, 5, 5],
                    curve: 'smooth'
                },
                plotOptions: {
                    bar: {
                        columnWidth: '50%'
                    }
                },
                fill: {
                    opacity: [1, 1, 1],
                    gradient: {
                        inverseColors: false,
                        shade: 'light',
                        type: "vertical",
                        opacityFrom: 0.85,
                        opacityTo: 0.55,
                        stops: [0, 100, 100, 100]
                    }
                },
                labels: ['PROGRESS VARIANT'],
                markers: {
                    size: 0
                },
                yaxis: {
                    title: {
                        text: 'PV',
                    },
                    min: 0,
                    forceNiceScale: true,
                },
                dataLabels: {
                    position: 'top',
                    style: {
                        colors: ['#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF']
                    }
                },
                tooltip: {
                    shared: true,
                    intersect: false,
                    y: {
                        formatter: function (y) {
                            if (typeof y !== "undefined") {
                                return y.toFixed(0) + " points";
                            }
                            return y;
                        }
                    }
                }
            },
            jumlahchecked: 0,
            jumlahcheckedcetak: 0,
            daftarlayer: [],
            daftarlayercetak: [],

            datamonitoring1: [],
            seriesmonitoring1: [],
            chartOptionsmonitoring1: {
                chart: {
                    width: '100%',
                    height: 450,
                    type: 'line',
                    zoom: {
                        type: 'x',
                        enabled: true,
                        autoScaleYaxis: true
                    },
                    toolbar: {
                        autoSelected: 'zoom'
                    }
                },
                colors: ['#00CED1', '#FFD700', '#9370DB', '#4682B4', '#32CD32'],
                dataLabels: {
                    enabled: true,
                },
                stroke: {
                    curve: 'smooth'
                },
                title: {
                    text: 'Progres',
                    align: 'center'
                },
                grid: {
                    borderColor: '#e7e7e7',
                    row: {
                        colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                        opacity: 0.5
                    },
                },
                markers: {
                    size: 1
                },
                xaxis: {
                    categories: [],
                    title: {
                        text: ''
                    }
                },
                yaxis: {
                    title: {
                        text: ''
                    },
                },
                legend: {
                    position: 'bottom',
                    floating: true,
                    offsetY: -10,
                    offsetX: -10,
                    show: true,
                }
            },
            tempjudul: [],
            temprencanafisik: [],
            temprencanakeu: [],
            temprealisasifisik: [],
            temprealisasikeu: [],
            tempdeviasifisik: [],
            tempdeviasikeu: [],
            awalminggu: 0,
            akhirminggu: 0,
            awalminggunya: 0,
            akhirminggunya: 0,
            idnya: '',
            mulainya: '',
            selesainya: '',
            kendalaarray: [],
            foto: '',
            foto_mingguke: '',
            kendala: '',
            tindaklanjut: '',
        };
    },
    methods: {
        ambilgambar(id) {
            var modal = document.getElementById("myModal");
            // Get the image and insert it inside the modal - use its "alt" text as a caption
            var img = document.getElementById(id);
            var modalImg = document.getElementById("img01");
            var captionText = document.getElementById("caption");
            modal.style.display = "block";
            modalImg.src = img.src;
            var alttemp = img.alt.split('#');
            if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                captionText.innerHTML = alttemp[0];
            }
            else {
                captionText.innerHTML = alttemp[1];
            }


            // Get the <span> element that closes the modal
            var span = document.getElementsByClassName("closenya")[0];

            // When the user clicks on <span> (x), close the modal
            span.onclick = function () {
                modal.style.display = "none";
            }

            var span2 = document.getElementsByClassName("closenya2")[0];

            // When the user clicks on <span> (x), close the modal
            span2.onclick = function () {
                modal.style.display = "none";
            }
        },
        tutupmodalkurvas() {
            $('#costumModalkurva').modal('hide');
        },
        tutupmodalgaleri() {
            $('#costumModalgaleri').modal('hide');
        },
        tutupmodaldokumen() {
            $('#costumModaldokumen').modal('hide');
        },
        async G_tableCSVTabel3(namefile) {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
                responseType: 'blob',
            });
            var random = Math.random();
            //alert(this.awalminggunya);
            //alert(this.akhirminggunya);
            const filename = this.G_formatDate(Date(), 'd-M-Y') + '_' + namefile + '.xlsx';
            await mainAPI5.get("parastapainnovationcetakresume-AWPDanKeu?random=" + random + "&project_id=" + this.project_id + "&showsatker=" + this.showAWPDetail).then(
                response => {
                    // Buat link download dari blob
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename); // nama file
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', 'Export gagal: ' + error, 'error');
                // this.ClearlocalStorage();
                console.log(error);
                this.halamanloading = false;
            });
        },
        async G_tableCSVTabelKomponen(namefile) {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
                responseType: 'blob',
            });
            var random = Math.random();
            //alert(this.awalminggunya);
            //alert(this.akhirminggunya);
            const filename = this.G_formatDate(Date(), 'd-M-Y') + '_' + namefile + '.xlsx';
            await mainAPI5.get("parastapainnovationcetakkomponen-Resume?random=" + random + "&project_id=" + this.project_id).then(
                response => {
                    // Buat link download dari blob
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename); // nama file
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', 'Export gagal: ' + error, 'error');
                // this.ClearlocalStorage();
                console.log(error);
                this.halamanloading = false;
            });
        },
        async G_tableCSVTabelKegiatan(namefile) {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
                responseType: 'blob',
            });
            var random = Math.random();
            //alert(this.awalminggunya);
            //alert(this.akhirminggunya);
            const filename = this.G_formatDate(Date(), 'd-M-Y') + namefile + '.xlsx';
            await mainAPI5.get("parastapainnovationcetak-ResumeKegiatan?random=" + random + "&project_id=" + this.project_id).then(
                response => {
                    // Buat link download dari blob
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename); // nama file
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', 'Export gagal: ' + error, 'error');
                // this.ClearlocalStorage();
                console.log(error);
                this.halamanloading = false;
            });
        },
        async G_tableCSVTabel4(namefile) {
            this.halamanloading = true;
            const XLSX = xlsx;
            var wb = XLSX.utils.table_to_book(document.getElementById('tabeldata4'), { sheet: "RekapKegiatan" });
            XLSX.writeFile(wb, this.G_formatDate(Date(), 'd-M-Y') + namefile + ".xlsx");
            this.halamanloading = false;
        },
        async G_tableCSVTabel5(namefile) {
            this.halamanloading = true;
            const XLSX = xlsx;
            var wb = XLSX.utils.table_to_book(document.getElementById('tabeldata5'), { sheet: "RekapOWP" });
            XLSX.writeFile(wb, this.G_formatDate(Date(), 'd-M-Y') + namefile + ".xlsx");
            this.halamanloading = false;
        },
        async G_tableCSVTabel6(namefile) {
            this.halamanloading = true;
            const XLSX = xlsx;
            var wb = XLSX.utils.table_to_book(document.getElementById('tabeldata6'), { sheet: "RekapAWP" });
            XLSX.writeFile(wb, this.G_formatDate(Date(), 'd-M-Y') + namefile + ".xlsx");
            this.halamanloading = false;
        },
        parsedatalayer() {
            this.dataunduhlayer = [];
            this.dataunduhlayer = JSON.parse(document.getElementById('detaildatamulti').value);
            //alert(this.dataunduhlayer.length);
            if (this.dataunduhlayer.length > 0) {
                this.datajudulunduhlayer = [];
                for (let i = 0; i < 1; i++) {
                    for (let x = 0; x < this.dataunduhlayer[i].length; x++) {
                        this.datajudulunduhlayer.push(this.dataunduhlayer[i][x].kolom);
                    }
                }
            }
        },
        informasidatalayer(layer) {
            if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                swal.fire({
                    title: "Konfirmasi",
                    text: "Untuk data dalam jumlah besar memerlukan waktu loading yang mungkin lama tergantung kondisi internet dan server, Yakin Hendak Memproses Data?",
                    icon: "warning",
                    showCancelButton: true,
                    cancelButtonText: "Batal",
                    confirmButtonColor: "#005c95",
                    cancelButtonColor: "#ffaa05",
                    confirmButtonText: "Proses"
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.halamanloading = true;
                        this.dataunduhlayer = [];
                        document.getElementById('paramlayerinformasi').value = '';
                        document.getElementById('paramlayerinformasi').value = layer;
                        document.getElementById("maps").contentWindow.document.getElementById('paramlayerinformasi').click();
                        this.halamanloading = false;
                    }
                });
            }
            else {
                swal.fire({
                    title: "Confirmation",
                    text: "For large amounts of data, it may take a long time to load, depending on internet and server conditions. Are you sure you want to process the data?",
                    icon: "warning",
                    showCancelButton: true,
                    cancelButtonText: "Cancel",
                    confirmButtonColor: "#005c95",
                    cancelButtonColor: "#ffaa05",
                    confirmButtonText: "Process"
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.halamanloading = true;
                        this.dataunduhlayer = [];
                        document.getElementById('paramlayerinformasi').value = '';
                        document.getElementById('paramlayerinformasi').value = layer;
                        document.getElementById("maps").contentWindow.document.getElementById('paramlayerinformasi').click();
                        this.halamanloading = false;
                    }
                });
            }
            $('.swal2-container').css("z-index", '999999');
            return false;
        },
        prosesdata(layer) {
            if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                swal.fire({
                    title: "Konfirmasi",
                    text: "Untuk data dalam jumlah besar memerlukan waktu loading yang mungkin lama tergantung kondisi internet dan server, Yakin Hendak Memproses Data?",
                    icon: "warning",
                    showCancelButton: true,
                    cancelButtonText: "Batal",
                    confirmButtonColor: "#005c95",
                    cancelButtonColor: "#ffaa05",
                    confirmButtonText: "Proses"
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.halamanloading = true;
                        this.dataunduhlayer = [];
                        document.getElementById('paramlayerunduh').value = '';
                        document.getElementById('paramlayerunduh').value = layer;
                        document.getElementById("maps").contentWindow.document.getElementById('paramlayerunduh').click();
                        this.halamanloading = false;
                    }
                });
            }
            else {
                swal.fire({
                    title: "Confirmation",
                    text: "For large amounts of data, it may take a long time to load, depending on internet and server conditions. Are you sure you want to process the data?",
                    icon: "warning",
                    showCancelButton: true,
                    cancelButtonText: "Cancel",
                    confirmButtonColor: "#005c95",
                    cancelButtonColor: "#ffaa05",
                    confirmButtonText: "Process"
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.halamanloading = true;
                        this.dataunduhlayer = [];
                        document.getElementById('paramlayerunduh').value = '';
                        document.getElementById('paramlayerunduh').value = layer;
                        document.getElementById("maps").contentWindow.document.getElementById('paramlayerunduh').click();
                        this.halamanloading = false;
                    }
                });
            }
            $('.swal2-container').css("z-index", '999999');
            return false;

        },
        tutupmodalinformasi() {
            $('#costumModalinformasidata').modal('hide');
        },
        tutupmodalresume() {
            $('#costumModalresume').modal('hide');
        },
        tutupmodal() {
            $('#costumModalunduhdata').modal('hide');
        },
        tutupmodalalokasi() {
            $('#costumModalalokasi').modal('hide');
        },
        async bukaresume() {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();
            await mainAPI.get("parastapainnovationmonitoringupdate-ProyekResume?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.dataproyek = [];
                        this.seriesproyek = [];

                        this.chartOptionsproyek = {
                            labels: []
                        };
                        this.dataproyek = Response.data.content.data;
                        this.tanggalsinkron = this.dataproyek[0].TanggalSinkronisasi;
                        this.tanggaldatamonev = this.dataproyek[0].TanggalDataMonev;
                        this.datamaster = this.dataproyek[0].OWP;
                        this.datatahun = this.dataproyek[0].Tahun;
                        this.totalawp = this.dataproyek[0].AWPTOTAL;
                        this.sisapagu = this.dataproyek[0].SISAPAGUTOTAL;
                        this.Realisasi = this.dataproyek[0].Realisasi;
                        this.PersenOWP = this.dataproyek[0].persenkeowp;
                        this.PVStatus = this.dataproyek[0].PVStatus;
                        this.ColorPVStatus = this.dataproyek[0].PVColor;
                        this.totalowp = this.datamaster.reduce((a, { OWP: e }) => a + e, 0);
                        //alert(this.totalowp);
                        this.datawaktu = [];
                        this.serieswaktu = [];
                        this.chartOptionswaktu = {
                            labels: []
                        };
                        this.datawaktu = Response.data.content.data;
                        this.datapv = [];
                        this.seriespv = [];

                        this.chartOptionspv = {
                            labels: []
                        };
                        this.datapv = Response.data.content.data;
                        this.chartOptionspv.plotOptions = {
                            pie: {
                                donut: {
                                    labels: {
                                        show: true,
                                        name: {
                                            formatter: function (value) {
                                                return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                                            },
                                        },
                                        value: {
                                            formatter: function (val) {
                                                return (val / 1).toFixed(2).replace('.', ',').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                                            }
                                        },
                                        total: {
                                            show: true,
                                            label: this.dataproyek[0].PVStatus,
                                            color: '#111',
                                            formatter: function (w) {
                                                return ''
                                            }
                                        }
                                    }
                                }
                            }
                        };
                        //alert(JSON.stringify(this.dataproyek));
                        this.seriesproyek.push(this.dataproyek[0].Realisasi);
                        this.seriesproyek.push(this.dataproyek[0].BelumRealisasi);

                        this.serieswaktu.push(this.datawaktu[0].ElapstimeusedBulan);
                        this.serieswaktu.push(this.datawaktu[0].WaktuLoanBulan - this.datawaktu[0].ElapstimeusedBulan);
                        var datapvnya = parseFloat(this.datapv[0].PV).toFixed(2);
                        var datakurangpvnya = parseFloat(this.datapv[0].PVRemaining).toFixed(2);
                        //alert(typeof parseFloat(datapvnya));
                        this.seriespv.push(parseFloat(datapvnya));
                        this.seriespv.push(parseFloat(datakurangpvnya));
                        //alert(this.seriespv);
                        this.chartOptionspv.colors = [this.datapv[0].PVColor, '#2176e6'];
                        var texttrilliyun = '';
                        var textrealisasi = '';
                        var textjudul = '';
                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            texttrilliyun = 'Dalam Triliyun (Rp.)';
                            textrealisasi = 'Realisasi';
                            textjudul = 'Perbandingan OWP, AWP dan Realisasi Kumulatif Tahunan';
                            this.chartOptionsproyek.labels.push('Sudah dicairkan');
                            this.chartOptionsproyek.labels.push('Belum dicairkan');
                            this.chartOptionsproyek.title = {
                                text: 'Realisasi Pencairan Proyek',
                                align: 'center',
                                margin: 10,
                                offsetX: 0,
                                offsetY: 0,
                                floating: false,
                                style: {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    fontFamily: 'Poppins-SemiBold, Arial',
                                    color: '#263238'
                                },
                            };

                            this.chartOptionswaktu.labels.push('Waktu terpakai');
                            this.chartOptionswaktu.labels.push('Waktu tersisa');
                            this.chartOptionswaktu.title = {
                                text: 'Rasio Waktu Proyek',
                                align: 'center',
                                margin: 10,
                                offsetX: 0,
                                offsetY: 0,
                                floating: false,
                                style: {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    fontFamily: 'Poppins-SemiBold, Arial',
                                    color: '#263238'
                                },
                            };

                            this.chartOptionspv.labels.push('Progress Variant');
                            this.chartOptionspv.labels.push('Kekurangan ke ideal');
                            this.chartOptionspv.title = {
                                text: 'Progress Variant',
                                align: 'center',
                                margin: 10,
                                offsetX: 0,
                                offsetY: 0,
                                floating: false,
                                style: {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    fontFamily: 'Poppins-SemiBold, Arial',
                                    color: '#263238'
                                },
                            };


                        }
                        else {
                            texttrilliyun = 'in Trilions (IDR)';
                            textrealisasi = 'Realization';
                            textjudul = 'Comparison of OWP, AWP and Annual Cumulative Realization';
                            this.chartOptionsproyek.labels.push('Disbursed');
                            this.chartOptionsproyek.labels.push('Undisbursed');
                            this.chartOptionsproyek.title = {
                                text: 'Realization of Project Disbursement',
                                align: 'center',
                                margin: 10,
                                offsetX: 0,
                                offsetY: 0,
                                floating: false,
                                style: {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    fontFamily: 'Poppins-SemiBold, Arial',
                                    color: '#263238'
                                },
                            };

                            this.chartOptionswaktu.labels.push('Elapse time');
                            this.chartOptionswaktu.labels.push('Time left');
                            this.chartOptionswaktu.title = {
                                text: 'Project Elapse Time Ratio',
                                align: 'center',
                                margin: 10,
                                offsetX: 0,
                                offsetY: 0,
                                floating: false,
                                style: {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    fontFamily: 'Poppins-SemiBold, Arial',
                                    color: '#263238'
                                },
                            };

                            this.chartOptionspv.labels.push('Progress Variant');
                            this.chartOptionspv.labels.push('Deviciency to ideals');
                            this.chartOptionspv.title = {
                                text: 'Progress Variant',
                                align: 'center',
                                margin: 10,
                                offsetX: 0,
                                offsetY: 0,
                                floating: false,
                                style: {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    fontFamily: 'Poppins-SemiBold, Arial',
                                    color: '#263238'
                                },
                            };
                        }

                        this.datamonitoring = [];
                        this.seriesmonitoring = [];
                        this.seriesbaru = [];
                        this.datamonitoring = Response.data.content.data;
                        var temptahun = [];
                        var tempowp = [];
                        var tempawp = [];
                        var tempspm = [];
                        var tempowpmonev = [];
                        var temprealisasimonev = [];
                        for (let i = 0; i < this.dataproyek[0].Tahun.length; i++) {
                            temptahun.push(this.dataproyek[0].Tahun[i].tahun);
                            tempowp.push(this.dataproyek[0].Tahun[i].owptrilyun);
                            tempawp.push(this.dataproyek[0].Tahun[i].awptrilyun);
                            tempspm.push(this.dataproyek[0].Tahun[i].spmtrilyun);
                            tempowpmonev.push(this.dataproyek[0].Tahun[i].dataowpmonevtrilyun);
                            temprealisasimonev.push(this.dataproyek[0].Tahun[i].datarealisasimonevtrilyun);
                        }

                        this.seriesmonitoring.push(
                            {
                                name: "OWP",
                                data: tempowp
                            },
                            {
                                name: "AWP",
                                data: tempawp
                            },
                            {
                                name: textrealisasi,
                                data: temprealisasimonev
                            }
                        )
                        this.seriesbaru = [{
                            name: 'OCR',
                            type: 'bar',
                            data: [this.dataproyek[0].PV_OCR.toFixed(2)],
                            color: this.dataproyek[0].PVColor_OCR
                        }, {
                            name: 'UK',
                            type: 'bar',
                            data: [this.dataproyek[0].PV_UK.toFixed(2)],
                            color: this.dataproyek[0].PVColor_UK
                        }, {
                            name: 'OCR + UK',
                            type: 'bar',
                            data: [this.dataproyek[0].PV.toFixed(2)],
                            color: this.dataproyek[0].PVColor
                        }];
                        //alert(temptahun);
                        this.chartOptionsmonitoring = {
                            title: {
                                text: textjudul,
                                align: 'center',
                                margin: 10,
                                offsetX: 0,
                                offsetY: 0,
                                floating: false,
                                style: {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    fontFamily: 'Poppins-SemiBold, Arial',
                                    color: '#263238'
                                },
                            },
                            xaxis: {
                                categories: temptahun,
                            },
                            yaxis: {
                                title: {
                                    text: texttrilliyun
                                },
                            },
                            legend: {
                                position: 'bottom',
                                floating: true,
                                offsetY: 5,
                                offsetX: -10,
                                show: true,
                            }
                        };

                        this.series_newpv = [{
                            data: []
                        }];

                        this.series_newpv = [{
                            data: [parseFloat(this.datapv[0].PV_OCR).toFixed(2), parseFloat(this.datapv[0].PV_UK).toFixed(2), parseFloat(this.datapv[0].PV).toFixed(2)]
                        }];

                        this.chartOptions_newpv = {
                            colors: [],
                            xaxis: {
                                categories: [],
                            },
                        }

                        this.chartOptions_newpv = {
                            colors: [this.datapv[0].PVColor_OCR, this.datapv[0].PVColor_UK, this.datapv[0].PVColor],
                            xaxis: {
                                categories: ['OCR  (' + this.datapv[0].PVStatus_OCR + ')', 'UK-ACGF TF (' + this.datapv[0].PVStatus_UK + ')', 'All (' + this.datapv[0].PVStatus + ')'],
                            },
                        }

                        this.datakomponen = Response.data.content.komponen;
                        this.dataresumetotal = Response.data.content.resume;
                        this.dataresume = Response.data.content.resumedetail;
                        var jenispekerjaan = [];
                        var jumlahkegiatan = [];
                        var persiapan = [];
                        var pra_tender = [];
                        var tender = [];
                        var ongoing = [];
                        var finish = [];
                        var masterjenispekerjaan = Response.data.content.resumedetail;
                        for (let i = 0; i < masterjenispekerjaan.length; i++) {
                            this.halamanloading = true;
                            jenispekerjaan.push(masterjenispekerjaan[i].JenisPekerjaan);
                            jumlahkegiatan.push(masterjenispekerjaan[i].jumlah);
                            for (let c = 0; c < masterjenispekerjaan[i].detail.length; c++) {
                                persiapan.push(masterjenispekerjaan[i].detail[c].persiapan);
                                tender.push(masterjenispekerjaan[i].detail[c].tender);
                                ongoing.push(masterjenispekerjaan[i].detail[c].ongoing);
                                finish.push(masterjenispekerjaan[i].detail[c].finish);
                            }
                            this.halamanloading = false;
                        }

                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.chartOptionsbar1 = {
                                title: {
                                    text: 'Jumlah Total Paket Dan Jenis Paket',
                                    align: 'center'
                                },
                                xaxis: {
                                    categories: jenispekerjaan,
                                },
                                yaxis: {
                                    title: {
                                        text: 'Jumlah Paket'
                                    }
                                },
                            };
                        }
                        else {
                            this.chartOptionsbar1 = {
                                title: {
                                    text: 'Total Number of Packages and Package Type',
                                    align: 'center'
                                },
                                xaxis: {
                                    categories: jenispekerjaan,
                                },
                                yaxis: {
                                    title: {
                                        text: 'Number of Packages'
                                    }
                                },
                            };
                        }

                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.seriesbar1 = [{
                                name: 'Total Kegiatan',
                                data: jumlahkegiatan
                            }, {
                                name: 'Persiapan Pengadaan',
                                data: persiapan
                            }, {
                                name: 'Lelang / Tahapan Pengadaan',
                                data: tender
                            }, {
                                name: 'Terkontrak / Pelaksanaan',
                                data: ongoing
                            }, {
                                name: 'Selesai',
                                data: finish
                            }]
                        }
                        else {
                            this.seriesbar1 = [{
                                name: 'Total Activity',
                                data: jumlahkegiatan
                            }, {
                                name: 'Procurement Preparation',
                                data: persiapan
                            }, {
                                name: 'Tender / Procurement Stages',
                                data: tender
                            }, {
                                name: 'On Going',
                                data: ongoing
                            }, {
                                name: 'Completed',
                                data: finish
                            }]
                        }
                        $('#costumModalresume').modal('show');
                        //alert(JSON.stringify(this.chartOptionsmonitoring.xaxis));
                    }
                    else {
                        this.totalowp = 0;
                        this.datamonitoring = [];
                        this.seriesmonitoring = [];
                        this.datamaster = [];
                        this.dataproyek = [];
                        this.seriesproyek = [];
                        this.dataresume = [];
                        this.dataresumetotal = [];
                        this.tanggalsinkron = new Date();
                        this.chartOptionsproyek = {
                            labels: []
                        };

                        this.datawaktu = [];
                        this.serieswaktu = [];
                        this.tanggalsinkron = new Date();
                        this.chartOptionswaktu = {
                            labels: []
                        };

                        this.datapv = [];
                        this.seriespv = [];
                        this.tanggalsinkron = new Date();
                        this.chartOptionspv = {
                            labels: []
                        };
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.totalowp = 0;
                this.datamaster = [];
                this.datamonitoring = [];
                this.seriesmonitoring = [];
                this.dataresume = [];
                this.dataresumetotal = [];
                this.dataproyek = [];
                this.seriesproyek = [];
                this.tanggalsinkron = new Date();
                this.chartOptionsproyek = {
                    labels: []
                };

                this.datawaktu = [];
                this.serieswaktu = [];
                this.tanggalsinkron = new Date();
                this.chartOptionswaktu = {
                    labels: []
                };

                this.datapv = [];
                this.seriespv = [];
                this.tanggalsinkron = new Date();
                this.chartOptionspv = {
                    labels: []
                };
                //console.log(error);
                this.halamanloading = false;
            });

        },
        async cekdataterpilihinformasi() {
            this.daftarunduhlayer = [];
            this.dataunduhlayer = [];
            var inputs = document.querySelectorAll("input[type='checkbox']");
            var checkboxesChecked = [];
            for (var i = 0; i < inputs.length; i++) {
                // And stick the checked ones onto an array...
                if (inputs[i].checked) {
                    var temp = inputs[i].id.split("|");
                    if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                        checkboxesChecked.push({
                            "id": temp[0],
                            "tipe": temp[12],
                            "namalayer": 'jateng' + temp[0] + '_' + temp[12],
                            "nama": 'Layer ' + temp[4],
                        });
                    }
                    else {
                        checkboxesChecked.push({
                            "id": temp[0],
                            "tipe": temp[12],
                            "namalayer": 'jateng' + temp[0] + '_' + temp[12],
                            "nama": temp[35] + ' Layer',
                        });
                    }
                }
            }
            if (checkboxesChecked.length == 0) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Data layer yang akan diunduh datanya belum dipilih, silahkan pilih dari menu layer peta',
                });
                return false;
            }
            this.daftarunduhlayer = checkboxesChecked;
            $('#costumModalinformasidata').modal('show');
            //alert(JSON.stringify(checkboxesChecked));
        },
        async cekdataterpilih() {
            this.daftarunduhlayer = [];
            this.dataunduhlayer = [];
            var inputs = document.querySelectorAll("input[type='checkbox']");
            var checkboxesChecked = [];
            for (var i = 0; i < inputs.length; i++) {
                // And stick the checked ones onto an array...
                if (inputs[i].checked) {
                    if ((inputs[i].id != 'customCheckboxAWPDetail') && (inputs[i].id != 'customCheckboxOWPDetail')) {
                        var temp = inputs[i].id.split("|");
                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            checkboxesChecked.push({
                                "id": temp[0],
                                "tipe": temp[12],
                                "namalayer": 'jateng' + temp[0] + '_' + temp[12],
                                "nama": 'Layer ' + temp[4],
                            });
                        }
                        else {
                            checkboxesChecked.push({
                                "id": temp[0],
                                "tipe": temp[12],
                                "namalayer": 'jateng' + temp[0] + '_' + temp[12],
                                "nama": temp[35] + ' Layer',
                            });
                        }
                    }
                }
            }
            if (checkboxesChecked.length == 0) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Data layer yang akan diunduh datanya belum dipilih, silahkan pilih dari menu layer peta',
                });
                return false;
            }
            this.daftarunduhlayer = checkboxesChecked;
            $('#costumModalunduhdata').modal('show');
            //alert(JSON.stringify(checkboxesChecked));
        },
        async G_tableCSVTabel1(namefile) {
            try {
                this.halamanloading = true;
                const XLSX = xlsx;
                var wb = XLSX.utils.table_to_book(document.getElementById('customers2'), { sheet: "DataLayerSimfast" });
                XLSX.writeFile(wb, this.G_formatDate(Date(), 'd-M-Y') + namefile + ".xlsx");
                this.halamanloading = false;
            } catch (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Data masih kosong',
                });
            }
        },
        async G_tableCSVTabelOWPAWP(namefile) {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
                responseType: 'blob',
            });
            var random = Math.random();
            //alert(this.awalminggunya);
            //alert(this.akhirminggunya);
            const filename = this.G_formatDate(Date(), 'd-M-Y') + '_' + namefile + '.xlsx';
            await mainAPI5.get("parastapainnovationcetakresume-ResumeOWP?random=" + random + "&project_id=" + this.project_id + "&showsatker=" + this.showOWPDetail).then(
                response => {
                    // Buat link download dari blob
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename); // nama file
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', 'Export gagal: ' + error, 'error');
                // this.ClearlocalStorage();
                console.log(error);
                this.halamanloading = false;
            });
        },
        async G_tableCSVTabel2(namefile) {
            try {
                this.halamanloading = true;
                const XLSX = xlsx;
                var wb = XLSX.utils.table_to_book(document.getElementById('tabeldataadidata'), { sheet: "DataDetailLayerSimfast" });
                XLSX.writeFile(wb, this.G_formatDate(Date(), 'd-M-Y') + namefile + ".xlsx");
                this.halamanloading = false;
            } catch (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Data masih kosong',
                });
            }
        },
        onlyNumberKey(evt) {
            // Only ASCII character in that range allowed
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();;
            } else {
                return true;
            } return;
        },
        onkabkotChange(a) {
            try {
                this.selectedkabkot = this.kabkot[a].tag;
            }
            catch (err) {
                return;
            }
        },
        ceklayer() {
            var cekbox = document.getElementById('paramkodecekbox').value;
            if (document.getElementById(cekbox).checked == true) {
                this.loadpeta();
            }
            else {
                this.loadpeta();
            }
        },
        InisialisasiTree() {
            $.fn.extend({
                treed: function (o) {

                    var openedClass = 'fas fa-minus';
                    var closedClass = 'fas fa-plus';

                    if (typeof o != 'undefined') {
                        if (typeof o.openedClass != 'undefined') {
                            openedClass = o.openedClass;
                        }
                        if (typeof o.closedClass != 'undefined') {
                            closedClass = o.closedClass;
                        }
                    };

                    //initialize each of the top levels
                    var tree = $(this);
                    tree.addClass("tree");
                    tree.find('li').has("ul").each(function () {
                        var branch = $(this); //li with children ul
                        branch.prepend("<i class='indicator glyphicon " + closedClass + "'></i>");
                        branch.addClass('branch');
                        branch.on('click', function (e) {
                            if (this == e.target) {
                                var icon = $(this).children('i:first');
                                icon.toggleClass(openedClass + " " + closedClass);
                                $(this).children().children().toggle();
                            }
                        })
                        branch.children().children().toggle();
                    });
                    //fire event from the dynamically added icon
                    tree.find('.branch .indicator').each(function () {
                        $(this).on('click', function () {
                            $(this).closest('li').click();
                        });
                    });
                    //fire event to open branch if the li contains an anchor instead of text
                    tree.find('.branch>a').each(function () {
                        $(this).on('click', function (e) {
                            $(this).closest('li').click();
                            e.preventDefault();
                        });
                    });
                    //fire event to open branch if the li contains a button instead of text
                    tree.find('.branch>button').each(function () {
                        $(this).on('click', function (e) {
                            $(this).closest('li').click();
                            e.preventDefault();
                        });
                    });
                }
            });
            //Initialization of treeviews
            $('#tree1').treed();
            $('#treelegenda').treed();
            $('.select2').select2();

            //Initialize Select2 Elements
            $('.select2bs4').select2({
                theme: 'bootstrap4'
            });
        },
        kembali() {
            window.location.replace("/");
        },
        closeNavInfo() {
            document.getElementById("myInfoLayer").style.width = "0";
        },
        openNavLayer() {
            this.closeNavPengaturan();
            this.closeNavLegenda();
            if (document.getElementById("mySidenavLayer").style.width == "380px") {
                document.getElementById("mySidenavLayer").style.width = "0";
            } else {
                document.getElementById("mySidenavLayer").style.width = "380px";
            }
        },
        closeNavLayer() {
            document.getElementById("mySidenavLayer").style.width = "0";
        },
        openNavPengaturan() {
            this.closeNavLayer();
            this.closeNavLegenda();
            if (document.getElementById("mySidenavPengaturan").style.width == "380px") {
                document.getElementById("mySidenavPengaturan").style.width = "0";
            } else {
                document.getElementById("mySidenavPengaturan").style.width = "380px";
            }
        },
        closeNavPengaturan() {
            document.getElementById("mySidenavPengaturan").style.width = "0";
        },
        openNavLegenda() {
            this.closeNavPengaturan();
            this.closeNavLayer();
            if (document.getElementById("mySidenavLegenda").style.width == "380px") {
                document.getElementById("mySidenavLegenda").style.width = "0";
            } else {
                document.getElementById("mySidenavLegenda").style.width = "380px";
            }
        },
        closeNavLegenda() {
            document.getElementById("mySidenavLegenda").style.width = "0";
        },
        cetakpeta() {
            this.daftarlayercetak = [];
            this.jumlahcheckedcetak = 0;
            var checkedCheckboxes = document.querySelectorAll('input[type="checkbox"]');
            var ids = Array.from(checkedCheckboxes).map(checkbox => checkbox.id);
            //alert(ids.length);
            //console.log(JSON.stringify(ids));
            //return false;
            var messagetemp = '';
            for (let i = 0; i < ids.length; i++) {
                if ((ids[i] != 'customCheckboxAWPDetail') && (ids[i] != 'customCheckboxOWPDetail')) {
                    this.jumlahcheckedcetak++;
                    this.daftarlayercetak.push(ids[i]);

                }
            }

            for (let x = 0; x < this.daftarlayercetak.length; x++) {
                this.halamanloading = true;
                try {
                    var ceknya = document.getElementById(this.daftarlayercetak[x]).checked;
                    messagetemp = this.linknya + '**' + ceknya + '**' + this.daftarlayercetak[x] + '******';
                    //alert(messagetemp);
                    const message = messagetemp;
                    const iframe = document.getElementById("iframefile");
                    this.sourcenyacetak = '';
                    this.sourcenyacetak = this.linknya + "ParastapaPeta-maps?pesan=";
                    iframe.contentWindow.postMessage(message, "*");
                    this.halamanloading = false;
                } catch (error) {
                    this.halamanloading = false;
                }
                this.halamanloading = false;
            }
            $('#costumModaldisclaimer').modal('show');
        },
        loadpdf() {
            this.daftarlayercetak = [];
            this.jumlahcheckedcetak = 0;
            var checkedCheckboxes = document.querySelectorAll('input[type="checkbox"]');
            var ids = Array.from(checkedCheckboxes).map(checkbox => checkbox.id);
            //alert(ids.length);
            //console.log(JSON.stringify(ids));
            //return false;
            var messagetemp = '';
            for (let i = 0; i < ids.length; i++) {
                if ((ids[i] != 'customCheckboxAWPDetail') && (ids[i] != 'customCheckboxOWPDetail')) {
                    this.jumlahcheckedcetak++;
                    this.daftarlayercetak.push(ids[i]);

                }
            }

            for (let x = 0; x < this.daftarlayercetak.length; x++) {
                this.halamanloading = true;
                try {
                    var ceknya = document.getElementById(this.daftarlayercetak[x]).checked;
                    messagetemp = this.linknya + '**' + ceknya + '**' + this.daftarlayercetak[x] + '******';
                    //alert(messagetemp);
                    const message = messagetemp;
                    const iframe = document.getElementById("iframefile");
                    this.sourcenyacetak = '';
                    this.sourcenyacetak = this.linknya + "ParastapaPeta-maps?pesan=";
                    iframe.contentWindow.postMessage(message, "*");
                    this.halamanloading = false;
                } catch (error) {
                    this.halamanloading = false;
                }
                this.halamanloading = false;
            }
        },
        tampilbasemap(tipenya) {
            document.getElementById("maps").contentWindow.document.getElementById(tipenya).click();
        },
        rubahisi() {
            if ((this.showHuman == false) && (this.capcha == this.capchainput.toUpperCase())) {
                if (this.nama.length <= 2) {
                    this.showHuman = false;
                    document.getElementById("customSwitchAuth").checked = false;
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Isikan nama dengan benar',
                    });
                    return false;
                }
                if ((this.hp.length <= 4) || (typeof parseInt(this.hp) != "number")) {
                    document.getElementById("customSwitchAuth").checked = false;
                    this.showHuman = false;
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Isikan nomor telp dengan benar',
                    });
                    return false;
                }
                if (this.keperluan.length <= 3) {
                    document.getElementById("customSwitchAuth").checked = false;
                    this.showHuman = false;
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Isikan keperluan dengan benar',
                    });
                    return false;
                }
                this.showHuman = true;
            }
            else {
                if (this.capcha != this.capchainput.toUpperCase()) {
                    document.getElementById("customSwitchAuth").checked = false;
                    this.showHuman = false;
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Kode keamanan tidak sama',
                    });
                }
                this.showHuman = false;
            }
        },
        async ambildata() {
            //alert(this.iduser);
            this.halamanloading = true;

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();

            await mainAPI.get("parastapainnovationip-Key?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.ipnya = Response.data.randkey;
                    }
                    else {
                        this.ipnya = '';
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = '';
                //console.log(error);
            });

            const mainAPI2 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            this.halamanloading = true;
            var random = Math.random();
            this.data_layer = [];
            await mainAPI2.get("maps_parastapainnovation-LayerPeta?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        document.getElementById("tree1").innerHTML = '';
                        this.data_layer = Response.data.content.data;
                        //alert(JSON.stringify(this.data_layer));
                        for (var i = 0; i < this.data_layer.length; i++) {
                            if (this.data_layer[i].id_parent == null) {
                                var iclassbuttonlihat = document.createElement("i");
                                iclassbuttonlihat.classList.add("fas");
                                iclassbuttonlihat.classList.add("fa-list-ul");
                                iclassbuttonlihat.classList.add("text-info");
                                iclassbuttonlihat.title = 'Filter Data';

                                var buttonlihat = document.createElement("BUTTON");
                                buttonlihat.setAttribute("id", 'list' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil + '|' + this.data_layer[i].nama_eng);
                                buttonlihat.classList.add("btn");
                                buttonlihat.classList.add("btn-tool");
                                buttonlihat.onclick = function () {
                                    var idselect = this.id.replace("list", "select");
                                    if (document.getElementById(idselect).style.display == 'none') {
                                        document.getElementById(idselect).style.display = 'block';
                                    } else {
                                        document.getElementById(idselect).style.display = 'none';
                                    }
                                };
                                buttonlihat.appendChild(iclassbuttonlihat);

                                var selectList = document.createElement("select");
                                selectList.setAttribute("id", 'select' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil + '|' + this.data_layer[i].nama_eng);

                                var cekboxlihat = document.createElement("input");
                                cekboxlihat.type = 'checkbox';
                                cekboxlihat.setAttribute("id", this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil + '|' + this.data_layer[i].nama_eng);
                                cekboxlihat.onclick = function () {
                                    document.getElementById('paramkodecekbox').value = this.id;
                                    document.getElementById('tombolparamkodecekbox').click();
                                };


                                var iclassbuttonradius = document.createElement("i");
                                iclassbuttonradius.classList.add("fas");
                                iclassbuttonradius.classList.add("fa-arrows-alt-h");
                                iclassbuttonradius.classList.add("text-info");
                                iclassbuttonradius.title = 'Setting Radius (m)';

                                var buttonradius = document.createElement("BUTTON");
                                buttonradius.setAttribute("id", 'listradius' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil + '|' + this.data_layer[i].nama_eng);
                                buttonradius.classList.add("btn");
                                buttonradius.classList.add("btn-tool");
                                buttonradius.onclick = function () {
                                    var idselectradius = this.id.replace("listradius", "radius");
                                    if (document.getElementById(idselectradius).style.display == 'none') {
                                        document.getElementById(idselectradius).style.display = 'block';
                                    } else {
                                        document.getElementById(idselectradius).style.display = 'none';
                                    }
                                };
                                buttonradius.appendChild(iclassbuttonradius);

                                var inputradius = document.createElement("input");
                                inputradius.type = 'number';
                                inputradius.value = this.data_layer[i].radius;
                                inputradius.setAttribute("id", 'radius' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil + '|' + this.data_layer[i].nama_eng);

                                var node = document.createElement("li");
                                //node.classList.add("branch");
                                node.setAttribute("id", this.data_layer[i].id);
                                if ((this.bahasa === null) || this.bahasa == 'ina') {
                                    var textnode = document.createTextNode(" " + this.data_layer[i].nama + " ");
                                }
                                else {
                                    var textnode = document.createTextNode(" " + this.data_layer[i].nama_eng + " ");
                                }
                                //var textnode = document.createTextNode(" " + this.data_layer[i].nama + " ");
                                if (this.data_layer[i].namajenismenu == 'Layer') {
                                    node.appendChild(cekboxlihat);
                                }
                                node.appendChild(textnode);
                                if (this.data_layer[i].kolomfilter != '') {
                                    node.appendChild(buttonlihat);
                                    node.appendChild(selectList);
                                }
                                if (this.data_layer[i].radius > 0) {
                                    node.appendChild(buttonradius);
                                    node.appendChild(inputradius);
                                }

                                if ((this.iduser != 'null') && (this.iduser != null) && (this.iduser != '')) {
                                    document.getElementById("tree1").appendChild(node);
                                }
                                else {
                                    if (this.data_layer[i].tampilpublik == 1) {
                                        document.getElementById("tree1").appendChild(node);
                                    }
                                }

                                if (this.data_layer[i].kolomfilter != '') {
                                    try {
                                        //document.getElementById(this.data_layer[i].id).style.textAlign = 'justify';
                                        var x = document.getElementById('select' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil + '|' + this.data_layer[i].nama_eng);
                                        //alert(this.data_layer[i].textfilter);
                                        var temparraytextfilter = this.data_layer[i].textfilter.split(",");
                                        if (temparraytextfilter.length > 0) {
                                            var option = document.createElement("option");
                                            option.value = '';
                                            option.text = 'Semua Data';
                                            x.add(option);
                                            for (var array = 0; array < temparraytextfilter.length; array++) {
                                                var option = document.createElement("option");
                                                option.value = temparraytextfilter[array];
                                                option.text = temparraytextfilter[array];
                                                x.add(option);
                                            }
                                        }
                                        x.select2();
                                    } catch (error) {

                                    }
                                }
                                try {
                                    document.getElementById('radius' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil).style.display = 'none';

                                } catch (error) {

                                }
                                try {
                                    document.getElementById('select' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil).style.display = 'none';
                                    document.getElementById('select' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil).style.fontSize = 'small';
                                    document.getElementById('select' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil).style.minWidth = '280px';
                                    document.getElementById('select' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil).style.maxWidth = '280px';
                                    document.getElementById(this.data_layer[i].id).style.paddingBottom = '5px';
                                } catch (error) {

                                }
                            }
                            else {

                                var iclassbuttonlihat = document.createElement("i");
                                iclassbuttonlihat.classList.add("fas");
                                iclassbuttonlihat.classList.add("fa-list-ul");
                                iclassbuttonlihat.classList.add("text-info");
                                iclassbuttonlihat.title = 'Filter Data';

                                var buttonlihat = document.createElement("BUTTON");
                                buttonlihat.setAttribute("id", 'list' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil + '|' + this.data_layer[i].nama_eng);
                                buttonlihat.classList.add("btn");
                                buttonlihat.classList.add("btn-tool");
                                buttonlihat.onclick = function () {
                                    var idselect = this.id.replace("list", "select");
                                    if (document.getElementById(idselect).style.display == 'none') {
                                        document.getElementById(idselect).style.display = 'block';
                                    } else {
                                        document.getElementById(idselect).style.display = 'none';
                                    }

                                };
                                buttonlihat.appendChild(iclassbuttonlihat);

                                var selectList = document.createElement("select");
                                selectList.setAttribute("id", 'select' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil + '|' + this.data_layer[i].nama_eng);

                                var iclassbuttonradius = document.createElement("i");
                                iclassbuttonradius.classList.add("fas");
                                iclassbuttonradius.classList.add("fa-arrows-alt-h");
                                iclassbuttonradius.classList.add("text-info");
                                iclassbuttonradius.title = 'Setting Radius (m)';

                                var buttonradius = document.createElement("BUTTON");
                                buttonradius.setAttribute("id", 'listradius' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil + '|' + this.data_layer[i].nama_eng);
                                buttonradius.classList.add("btn");
                                buttonradius.classList.add("btn-tool");
                                buttonradius.onclick = function () {
                                    var idselectradius = this.id.replace("listradius", "radius");
                                    if (document.getElementById(idselectradius).style.display == 'none') {
                                        document.getElementById(idselectradius).style.display = 'block';
                                    } else {
                                        document.getElementById(idselectradius).style.display = 'none';
                                    }
                                };
                                buttonradius.appendChild(iclassbuttonradius);

                                var cekboxlihat = document.createElement("input");
                                cekboxlihat.type = 'checkbox';
                                cekboxlihat.setAttribute("id", this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil + '|' + this.data_layer[i].nama_eng);
                                cekboxlihat.onclick = function () {
                                    document.getElementById('paramkodecekbox').value = this.id;
                                    document.getElementById('tombolparamkodecekbox').click();
                                };

                                var inputradius = document.createElement("input");
                                inputradius.type = 'number';
                                inputradius.value = this.data_layer[i].radius;
                                inputradius.setAttribute("id", 'radius' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil + '|' + this.data_layer[i].nama_eng);

                                var node = document.createElement("li");
                                //node.classList.add("branch");
                                node.setAttribute("id", this.data_layer[i].id);
                                if ((this.bahasa === null) || this.bahasa == 'ina') {
                                    var textnode = document.createTextNode(" " + this.data_layer[i].nama + " ");
                                }
                                else {
                                    var textnode = document.createTextNode(" " + this.data_layer[i].nama_eng + " ");
                                }
                                //var textnode = document.createTextNode(" " + this.data_layer[i].nama + " ");
                                if (this.data_layer[i].namajenismenu == 'Layer') {
                                    node.appendChild(cekboxlihat);
                                }

                                if (this.data_layer[i].kolomfilter != '') {
                                    node.appendChild(buttonlihat);
                                    node.appendChild(selectList);
                                }
                                if (this.data_layer[i].radius > 0) {
                                    node.appendChild(buttonradius);
                                    node.appendChild(inputradius);
                                }
                                node.appendChild(textnode);
                                var ul = document.createElement("ul");
                                ul.setAttribute("id", "ul" + this.data_layer[i].id);
                                ul.appendChild(node);
                                if ((this.iduser != 'null') && (this.iduser != null) && (this.iduser != '')) {
                                    document.getElementById(this.data_layer[i].id_parent).appendChild(ul);
                                }
                                else {
                                    if (this.data_layer[i].tampilpublik == 1) {
                                        document.getElementById(this.data_layer[i].id_parent).appendChild(ul);
                                    }
                                }

                                //document.getElementById(this.data_layer[i].id_parent).appendChild(ul);
                                if (this.data_layer[i].kolomfilter != '') {
                                    try {
                                        //document.getElementById(this.data_layer[i].id).style.textAlign = 'justify';
                                        var x = document.getElementById('select' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil + '|' + this.data_layer[i].nama_eng);
                                        //alert(this.data_layer[i].textfilter);
                                        var temparraytextfilter = this.data_layer[i].textfilter.split(",");
                                        if (temparraytextfilter.length > 0) {
                                            var option = document.createElement("option");
                                            option.value = '';
                                            option.text = 'Semua Data';
                                            x.add(option);
                                            for (var array = 0; array < temparraytextfilter.length; array++) {
                                                var option = document.createElement("option");
                                                option.value = temparraytextfilter[array];
                                                option.text = temparraytextfilter[array];
                                                x.add(option);
                                            }
                                        }
                                        x.select2();
                                    } catch (error) {

                                    }
                                }
                                try {
                                    document.getElementById('radius' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil).style.display = 'none';

                                } catch (error) {

                                }
                                try {
                                    //document.getElementById(this.data_layer[i].id).style.textAlign = 'justify';
                                    document.getElementById('select' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil).style.display = 'none';
                                    document.getElementById('select' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil).style.fontSize = 'small';
                                    document.getElementById('select' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil).style.minWidth = '280px';
                                    document.getElementById('select' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil).style.maxWidth = '280px';
                                    document.getElementById(this.data_layer[i].id).style.paddingBottom = '5px';
                                } catch (error) {

                                }
                            }
                        }
                        $('#tree1').treed();

                    }
                    else {
                        this.data_layer = [];
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = '';
                this.data_layer = [];
                //console.log(error);
                this.halamanloading = false;
            });

            this.halamanloading = true;
            var random = Math.random();
            this.data_layer = [];
            await mainAPI2.get("maps_parastapainnovation-LayerPeta?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        document.getElementById("treelegenda").innerHTML = '';
                        this.data_layer = Response.data.content.data;
                        //alert(JSON.stringify(this.data_layer));
                        for (var i = 0; i < this.data_layer.length; i++) {
                            if (this.data_layer[i].id_parent == null) {

                                var node = document.createElement("li");
                                //node.classList.add("branch");
                                node.setAttribute("id", this.data_layer[i].id);
                                if ((this.bahasa === null) || this.bahasa == 'ina') {
                                    var textnode = document.createTextNode(" " + this.data_layer[i].nama + " ");
                                }
                                else {
                                    var textnode = document.createTextNode(" " + this.data_layer[i].nama_eng + " ");
                                }

                                node.appendChild(textnode);

                                if ((this.iduser != 'null') && (this.iduser != null) && (this.iduser != '')) {
                                    document.getElementById("treelegenda").appendChild(node);
                                }
                                else {
                                    if (this.data_layer[i].tampilpublik == 1) {
                                        document.getElementById("treelegenda").appendChild(node);
                                    }
                                }

                                try {
                                    document.getElementById(this.data_layer[i].id).style.paddingBottom = '5px';
                                } catch (error) {

                                }
                            }
                            else {
                                var node = document.createElement("li");
                                //node.classList.add("branch");
                                //alert(this.data_layer[i].id);
                                node.setAttribute("id", this.data_layer[i].id);
                                if ((this.bahasa === null) || this.bahasa == 'ina') {
                                    var textnode = document.createTextNode(" " + this.data_layer[i].nama + " ");
                                }
                                else {
                                    var textnode = document.createTextNode(" " + this.data_layer[i].nama_eng + " ");
                                }
                                node.appendChild(textnode);
                                if ((this.data_layer[i].jenis == '2') && (this.data_layer[i].legenda != '')) {
                                    //alert(atob(this.data_layer[i].legenda));
                                    //return;
                                    var arraylegenda = JSON.parse(atob(this.data_layer[i].legenda));
                                    //alert(arraylegenda.length);

                                    for (var z = 0; z < arraylegenda.length; z++) {
                                        // awal legenda
                                        if ((arraylegenda[z].keterangan == 'gambar') || (arraylegenda[z].keterangan == 'Sesuai Pengaturan Point')) {
                                            // awal gambar
                                            var nodelegenda = document.createElement("li");
                                            //node.classList.add("branch");
                                            nodelegenda.setAttribute("id", 'legenda' + this.data_layer[i].id);

                                            var gambar = document.createElement('img');
                                            if (arraylegenda[z].kolom.toString().trim().includes("http")) {
                                                gambar.src = arraylegenda[z].kolom;
                                            }
                                            else {
                                                gambar.src = this.linknya + 'maps_parastapainnovation-Ikon?f=' + arraylegenda[z].kolom;
                                            }

                                            gambar.style.height = '15px';
                                            //nodelegenda.appendChild(gambar);
                                            var buttonlihat = document.createElement("BUTTON");
                                            buttonlihat.setAttribute("id", 'listlegenda' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil);
                                            buttonlihat.classList.add("btn");
                                            buttonlihat.classList.add("btn-tool");
                                            buttonlihat.appendChild(gambar);
                                            nodelegenda.appendChild(buttonlihat);

                                            if (arraylegenda[z].keterangan.toString().trim().toUpperCase().includes("SESUAI")) {
                                                if ((this.bahasa === null) || this.bahasa == 'ina') {
                                                    var textnodelegenda = document.createTextNode(" " + arraylegenda[z].namalayer + " ");
                                                }
                                                else {
                                                    var textnodelegenda = document.createTextNode(" " + arraylegenda[z].namalayer_eng + " ");
                                                }
                                            }

                                            else {
                                                var textnodelegenda = document.createTextNode(" " + arraylegenda[z].isian + " ");
                                            }

                                            nodelegenda.appendChild(textnodelegenda);

                                            var ullegenda = document.createElement("ul");
                                            ullegenda.setAttribute("id", "ullegenda" + this.data_layer[i].id);
                                            ullegenda.appendChild(nodelegenda);
                                            node.appendChild(ullegenda);

                                            // akhir gambar
                                        }
                                        else {
                                            // awal bukan gambar
                                            var nodelegenda = document.createElement("li");
                                            //node.classList.add("branch");
                                            nodelegenda.setAttribute("id", 'legenda' + this.data_layer[i].id);
                                            var iclassbuttonlihat = document.createElement("i");
                                            iclassbuttonlihat.classList.add("fas");
                                            if ((arraylegenda[z].keterangan == 'fill') || (arraylegenda[z].keterangan == 'Sesuai Pengaturan Polygon') || (arraylegenda[z].keterangan == 'Sesuai Pengaturan Radius')) {
                                                if ((arraylegenda[z].tipe_fill == 'Pattern')) {
                                                    if ((arraylegenda[z].tipe_pattern == 'crosses') || (arraylegenda[z].tipe_pattern == '6')) {
                                                        iclassbuttonlihat.classList.add("fa-chess-board");
                                                    }
                                                    else if ((arraylegenda[z].tipe_pattern == 'cross') || (arraylegenda[z].tipe_pattern == '2')) {
                                                        iclassbuttonlihat.classList.add("fa-border-all");
                                                    }
                                                    else if ((arraylegenda[z].tipe_pattern == 'hatch') || (arraylegenda[z].tipe_pattern == '1')) {
                                                        iclassbuttonlihat.classList.add("fa-bars");
                                                    }
                                                    else if ((arraylegenda[z].tipe_pattern == 'dot') || (arraylegenda[z].tipe_pattern == '3')) {
                                                        iclassbuttonlihat.classList.add("fa-qrcode");
                                                    }
                                                    else if ((arraylegenda[z].tipe_pattern == 'brick') || (arraylegenda[z].tipe_pattern == '4')) {
                                                        iclassbuttonlihat.classList.add("fa-compress");
                                                    }
                                                    else if ((arraylegenda[z].tipe_pattern == 'wave') || (arraylegenda[z].tipe_pattern == '5')) {
                                                        iclassbuttonlihat.classList.add("fa-water");
                                                    }
                                                    else if ((arraylegenda[z].tipe_pattern == 'rock') || (arraylegenda[z].tipe_pattern == '7')) {
                                                        iclassbuttonlihat.classList.add("fa-grip-horizontal");
                                                    }
                                                    else {
                                                        iclassbuttonlihat.classList.add("fa-object-group");
                                                    }
                                                }
                                                else {
                                                    iclassbuttonlihat.classList.add("fa-square-full");
                                                }
                                            }
                                            else {
                                                if (arraylegenda[z].isian.toString().trim().toUpperCase().includes("SUNGAI")) {
                                                    iclassbuttonlihat.classList.add("fa-signature");
                                                }
                                                else {
                                                    iclassbuttonlihat.classList.add("fa-minus");
                                                }

                                            }
                                            //iclassbuttonlihat.classList.add("fa-signature");
                                            //iclassbuttonlihat.classList.add("fa-bacon");
                                            //iclassbuttonlihat.classList.add("fa-square-full");
                                            //iclassbuttonlihat.classList.add("fa-chess-board");
                                            //iclassbuttonlihat.classList.add("fa-border-all");

                                            iclassbuttonlihat.style.color = arraylegenda[z].kolom;
                                            //iclassbuttonlihat.classList.add("text-info");

                                            var buttonlihat = document.createElement("BUTTON");
                                            buttonlihat.setAttribute("id", 'listlegenda' + this.data_layer[i].id + '|' + this.data_layer[i].level + '|' + this.data_layer[i].id_parent + '|' + this.data_layer[i].urut + '|' + this.data_layer[i].nama + '|' + this.data_layer[i].jenis + '|' + this.data_layer[i].namajenismenu + '|' + this.data_layer[i].asal_peta + '|' + this.data_layer[i].namaasalpeta + '|' + this.data_layer[i].api + '|' + this.data_layer[i].namaapipeta + '|' + this.data_layer[i].filenya_peta + '|' + this.data_layer[i].tipe_peta + '|' + this.data_layer[i].namatipepeta + '|' + this.data_layer[i].fill + '|' + this.data_layer[i].stroke + '|' + this.data_layer[i].fill_width + '|' + this.data_layer[i].stroke_width + '|' + this.data_layer[i].dash_start + '|' + this.data_layer[i].dash_end + '|' + this.data_layer[i].filenya_ikon + '|' + this.data_layer[i].tipe_fill + '|' + this.data_layer[i].namatipefill + '|' + this.data_layer[i].tipe_pattern + '|' + this.data_layer[i].namatipepattern + '|' + this.data_layer[i].sudut + '|' + this.data_layer[i].urutindex + '|' + this.data_layer[i].latitude + '|' + this.data_layer[i].longitude + '|' + this.data_layer[i].zoom + '|' + this.data_layer[i].radius + '|' + this.data_layer[i].kolomfilter + '|' + this.data_layer[i].textfilter + '|' + this.data_layer[i].tampilpublik + '|' + this.data_layer[i].namastatustampil);
                                            buttonlihat.classList.add("btn");
                                            buttonlihat.classList.add("btn-tool");
                                            buttonlihat.appendChild(iclassbuttonlihat);
                                            nodelegenda.appendChild(buttonlihat);

                                            if (arraylegenda[z].keterangan.toString().trim().toUpperCase().includes("SESUAI")) {
                                                if ((this.bahasa === null) || this.bahasa == 'ina') {
                                                    var textnodelegenda = document.createTextNode(" " + arraylegenda[z].namalayer + " ");
                                                }
                                                else {
                                                    var textnodelegenda = document.createTextNode(" " + arraylegenda[z].namalayer_eng + " ");
                                                }
                                            }

                                            else {
                                                var textnodelegenda = document.createTextNode(" " + arraylegenda[z].isian + " ");
                                            }
                                            nodelegenda.appendChild(textnodelegenda);

                                            var ullegenda = document.createElement("ul");
                                            ullegenda.setAttribute("id", "ullegenda" + this.data_layer[i].id);
                                            ullegenda.appendChild(nodelegenda);
                                            node.appendChild(ullegenda);
                                            // akhir bukan gambar
                                        }
                                        // akhir legenda


                                    }
                                }


                                var ul = document.createElement("ul");
                                ul.setAttribute("id", "ul" + this.data_layer[i].id);
                                ul.appendChild(node);
                                //ul.appendChild(ullegenda);

                                if ((this.iduser != 'null') && (this.iduser != null) && (this.iduser != '')) {
                                    document.getElementById(this.data_layer[i].id_parent).appendChild(ul);
                                }
                                else {
                                    if (this.data_layer[i].tampilpublik == 1) {
                                        document.getElementById(this.data_layer[i].id_parent).appendChild(ul);
                                    }
                                }

                                try {
                                    document.getElementById(this.data_layer[i].id).style.paddingBottom = '5px';
                                } catch (error) {

                                }
                            }
                        }
                        $('#treelegenda').treed();
                    }
                    else {
                        this.data_layer = [];
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = '';
                this.data_layer = [];
                console.log(error);
                this.halamanloading = false;
            });
        },
        loadpeta() {
            this.halamanloading = true;
            try {
                var tempceknya = document.getElementById('paramkodecekbox').value;
                var ceknya = document.getElementById(tempceknya).checked;
                try {
                    this.selectedfilter = document.getElementById('select' + tempceknya).value.trim();
                } catch (error) {
                    this.selectedfilter = '';
                }
                try {
                    this.selectedradius = document.getElementById('radius' + tempceknya).value.trim();
                } catch (error) {
                    this.selectedradius = '0';
                }

                var messagetemp = this.linknya + '**' + ceknya + '**' + document.getElementById('paramkodecekbox').value + '**' + this.selectedkabkot + '**' + this.selectedfilter + '**' + this.selectedradius;
            } catch (error) {
                var ceknya = false;
                var messagetemp = this.linknya + '**' + ceknya + '**' + document.getElementById('paramkodecekbox').value + '**' + this.selectedkabkot + '**' + this.selectedfilter + '**' + this.selectedradius;
            }
            //alert(this.selectedfilter);
            const message = messagetemp;
            const iframe = document.getElementById("maps");
            this.sourcenya = '';
            this.sourcenya = '/gis.html';
            iframe.contentWindow.postMessage(message, "*");
            this.halamanloading = false;
        },
        koordinatkosong() {
            swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000
            }).fire({
                icon: 'warning',
                title: 'Koordinat belum diisi..',
            });
            $('.swal2-container').css("z-index", '999999');
        },
        datakosonglayer() {
            this.halamanloading = false;
            swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000
            }).fire({
                icon: 'warning',
                title: 'Data Layer ' + document.getElementById('isidatakosong').value + ' Tidak Tersedia..',
            });
            $('.swal2-container').css("z-index", '999999');

        },
        datakosong() {
            swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000
            }).fire({
                icon: 'warning',
                title: 'Data Layer Gagal Diunduh..',
            });
            $('.swal2-container').css("z-index", '999999');
        },
        openNavInfoBawah() {
            this.galeri = [];
            try {
                //alert(document.getElementById('acuanj2a098002').innerHTML);
                var tempdata = document.getElementById('acuanj2a098002').innerHTML;
                //alert(tempdata);
                //return;
                this.galeri = JSON.parse(tempdata);

                this.ambildatagaleri();

            } catch (error) {

            }
        },
        openNavInfoBawahKec() {
            try {
                //alert(document.getElementById('acuankecj2a098002').innerHTML);
                var tempdata = document.getElementById('acuankecj2a098002').innerHTML;
                this.dokumen = JSON.parse(tempdata);
                //alert(JSON.stringify(this.dokumen));
                this.ambildatadokumen();

            } catch (error) {

            }
        },
        openNavInfoBawahKurva() {
            try {
                //alert(document.getElementById('acuanj2a098002').innerHTML);
                var tempdata = document.getElementById('acuankurvaj2a098002').innerHTML;
                this.kurva = JSON.parse(tempdata);
                this.ambildatakurva();

            } catch (error) {

            }
        },
        openNavInfoBawahDesa() {
            try {
                //alert(document.getElementById('acuanj2a098002').innerHTML);
                var tempdata = document.getElementById('acuandesaj2a098002').innerHTML.split('_');
                this.selectedkabkotalokasi = tempdata[0];
                if (tempdata[1] != "Semua Tahun") {
                    this.selectedtahunalokasi = tempdata[1];
                }
                else {
                    this.selectedtahunalokasi = '';
                }
                this.ambildataalokasi(tempdata[0]);

            } catch (error) {

            }
        },
        getOtentifikasi() {
            var time = Date.parse(localStorage.getItem("tsistem"));
            var timeakhir = time + (3 * 60 * 60 * 1000);
            var timesekarang = Date.parse(new Date());
            if (timesekarang > timeakhir) {
                this.JustClearlocalStorage();
            }
        },
        async ambildatakurva() {
            //alert(this.kurva);
            var temppp = this.kurva.split("#")
            this.idnya = temppp[0];
            this.mulainya = temppp[1];
            this.selesainya = temppp[2];
            this.Nama_Kegiatan = '';
            this.Lokasi = '';
            this.KONTRAKTOR = '';
            this.NILAIKONTRAK = '';
            this.MULAI = '';
            this.SELESAI = '';
            this.ADENDUM = '';
            this.tanggal1 = '';
            this.tanggal2 = '';
            this.AWP = '';
            this.foto = '';
            this.foto_mingguke = '';
            this.kendala = '';
            this.kendalaarray = [];
            this.tindaklanjut = '';
            if (this.mulainya == '0000-00-00' || this.selesainya == '0000-00-00' || this.mulainya == '' || this.selesainya == '' || this.mulainya == null || this.selesainya == null) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Tanggal kontrak belum diisi..',
                });
                $('.swal2-container').css("z-index", '999999');
                return false;
            }
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();
            //alert(this.akhirminggu);
            await mainAPI5.get("parastapainnovationmonitoring-KurvaS?random=" + random + "&project_id=" + this.project_id + "&kode=" + this.idnya + "&awalminggu=" + this.awalminggu + "&akhirminggu=" + this.akhirminggu).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.Nama_Kegiatan = Response.data.content.Nama_Kegiatan[0].Nama_Kegiatan;
                        this.Lokasi = Response.data.content.Nama_Kegiatan[0].Lokasi;
                        this.KONTRAKTOR = Response.data.content.Nama_Kegiatan[0].KONTRAKTOR;
                        this.NILAIKONTRAK = Response.data.content.Nama_Kegiatan[0].NILAIKONTRAK;
                        this.MULAI = Response.data.content.Nama_Kegiatan[0].MULAI;
                        this.SELESAI = Response.data.content.Nama_Kegiatan[0].SELESAI;
                        this.ADENDUM = Response.data.content.Nama_Kegiatan[0].ADENDUM;
                        this.tanggal1 = Response.data.content.Nama_Kegiatan[0].tanggal1;
                        this.tanggal2 = Response.data.content.Nama_Kegiatan[0].tanggal2;
                        this.AWP = Response.data.content.Nama_Kegiatan[0].AWP;
                        this.foto = Response.data.content.Nama_Kegiatan[0].foto;
                        this.foto_mingguke = Response.data.content.Nama_Kegiatan[0].foto_mingguke;
                        this.kendalaarray = Response.data.content.Kendala;
                        this.kendala = atob(Response.data.content.Nama_Kegiatan[0].kendala);
                        this.tindaklanjut = atob(Response.data.content.Nama_Kegiatan[0].tindaklanjut);
                        this.tempjudul = [];
                        this.temprencanafisik = [];
                        this.temprencanakeu = [];
                        this.temprealisasifisik = [];
                        this.temprealisasikeu = [];
                        this.tempdeviasifisik = [];
                        this.tempdeviasikeu = [];
                        this.awalminggu = 0;
                        this.akhirminggu = 0;
                        this.awalminggunya = 0;
                        this.akhirminggunya = 0;
                        this.seriesmonitoring = [];
                        this.chartOptionsmonitoring = {};

                        for (let i = 0; i < Response.data.content.data.length; i++) {
                            this.tempjudul.push(Response.data.content.data[i].minggu_ke);
                            this.temprencanafisik.push(Response.data.content.data[i].rencana_fisik);
                            this.temprencanakeu.push(Response.data.content.data[i].rencana_keuangan);
                            this.temprealisasifisik.push(Response.data.content.data[i].real_fisik);
                            this.temprealisasikeu.push(Response.data.content.data[i].real_keuangan);
                            this.tempdeviasifisik.push(Response.data.content.data[i].deviasi_fisik);
                            this.tempdeviasikeu.push(Response.data.content.data[i].deviasi_keuangan);
                        }
                        this.awalminggu = Response.data.content.awalminggu;
                        this.akhirminggu = Response.data.content.jumlahminggu;
                        this.awalminggunya = Response.data.content.awalminggu;
                        this.akhirminggunya = Response.data.content.jumlahminggu;
                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            var textjudul = 'Progres Realisasi Fisik Dan Keuangan';
                            var textrencanafisik = 'Rencana Fisik';
                            var textrencanakeuangan = 'Rencana Keuangan';
                            var textrealisasifisik = 'Realisasi Fisik';
                            var textrealisasikeuangan = 'Realisasi Keuangan';
                            var textaxis = 'Capaian';
                        }
                        else {
                            var textjudul = 'Physical and Financial Realization Progress';
                            var textrencanafisik = 'Physical Plan';
                            var textrencanakeuangan = 'Financial Plan';
                            var textrealisasifisik = 'Physical Realization';
                            var textrealisasikeuangan = 'Financial Realization';
                            var textaxis = 'Achievements';
                        }

                        this.seriesmonitoring1.push(
                            {
                                name: textrencanafisik,
                                data: this.temprencanafisik
                            },
                            {
                                name: textrencanakeuangan,
                                data: this.temprencanakeu
                            },
                            {
                                name: textrealisasifisik,
                                data: this.temprealisasifisik
                            },
                            {
                                name: textrealisasikeuangan,
                                data: this.temprealisasikeu
                            }
                        )
                        //alert(temptahun);
                        this.chartOptionsmonitoring1 = {
                            title: {
                                text: textjudul,
                                align: 'center',
                                margin: 10,
                                offsetX: 0,
                                offsetY: 0,
                                floating: false,
                                style: {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    fontFamily: 'PragmaticaBook, Arial',
                                    color: '#263238'
                                },
                            },
                            xaxis: {
                                categories: this.tempjudul,
                            },
                            yaxis: {
                                title: {
                                    text: textaxis
                                },
                            },
                            legend: {
                                position: 'bottom',
                                floating: true,
                                offsetY: 10,
                                offsetX: -5,
                                show: true,
                            }
                        };
                        this.halamanloading = false;
                        $('#costumModalkurva').modal('show');
                    }
                    else {
                        this.seriesmonitoring1 = [];
                        this.chartOptionsmonitoring1 = {};
                        this.Nama_Kegiatan = '';
                        this.Lokasi = '';
                        this.KONTRAKTOR = '';
                        this.NILAIKONTRAK = '';
                        this.MULAI = '';
                        this.SELESAI = '';
                        this.ADENDUM = '';
                        this.tanggal1 = '';
                        this.tanggal2 = '';
                        this.AWP = '';
                        this.foto = '';
                        this.foto_mingguke = '';
                        this.kendala = '';
                        this.kendalaarray = [];
                        this.tindaklanjut = '';
                        this.akhirminggu = 0;
                        this.awalminggu = 0;
                        this.awalminggunya = 0;
                        this.akhirminggunya = 0;
                        this.halamanloading = false;
                    }

                }
            ).catch(error => {
                console.log(error);
                this.seriesmonitoring1 = [];
                this.chartOptionsmonitoring1 = {};
                this.Nama_Kegiatan = '';
                this.Lokasi = '';
                this.KONTRAKTOR = '';
                this.NILAIKONTRAK = '';
                this.MULAI = '';
                this.SELESAI = '';
                this.ADENDUM = '';
                this.tanggal1 = '';
                this.tanggal2 = '';
                this.AWP = '';
                this.foto = '';
                this.foto_mingguke = '';
                this.kendala = '';
                this.kendalaarray = [];
                this.tindaklanjut = '';
                this.akhirminggu = 0;
                this.awalminggu = 0;
                this.awalminggunya = 0;
                this.akhirminggunya = 0;
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });
        },
        async ambildatagaleri() {
            $('#costumModalgaleri').modal('show');
        },
        async ambildatadokumen() {
            //alert(JSON.stringify(this.dokumen));
            $('#costumModaldokumen').modal('show');
        },
        tutupmodalkurvas() {
            $('#costumModalkurva').modal('hide');
        },
        async ambildatareff() {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();

            await mainAPI.get("parastapainnovationip-Key?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.ipnya = Response.data.randkey;
                    }
                    else {
                        this.ipnya = '';
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = [];
                //console.log(error);
            });
            this.halamanloading = true;
            const mainAPI2 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });

        },

    },
    mounted() {
        this.getOtentifikasi();
        this.ambildatareff();
        this.ambildata();
        this.InisialisasiTree();
    },
}
</script>

<style></style>